import React from 'react';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

var renderErr = 'Renderer Error ☝️';
var actions = {
  init: 'init'
};
var defaultColumn = {
  Cell: function Cell(_ref) {
    var _ref$cell$value = _ref.cell.value,
        value = _ref$cell$value === void 0 ? '' : _ref$cell$value;
    return value;
  },
  width: 150,
  minWidth: 0,
  maxWidth: Number.MAX_SAFE_INTEGER
};
function defaultOrderByFn(arr, funcs, dirs) {
  return [].concat(arr).sort(function (rowA, rowB) {
    for (var i = 0; i < funcs.length; i += 1) {
      var sortFn = funcs[i];
      var desc = dirs[i] === false || dirs[i] === 'desc';
      var sortInt = sortFn(rowA, rowB);

      if (sortInt !== 0) {
        return desc ? -sortInt : sortInt;
      }
    }

    return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
  });
}
function defaultGroupByFn(rows, columnId) {
  return rows.reduce(function (prev, row, i) {
    // TODO: Might want to implement a key serializer here so
    // irregular column values can still be grouped if needed?
    var resKey = "" + row.values[columnId];
    prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
    prev[resKey].push(row);
    return prev;
  }, {});
}

function mergeProps() {
  for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) {
    propList[_key] = arguments[_key];
  }

  return propList.reduce(function (props, next) {
    var style = next.style,
        className = next.className,
        rest = _objectWithoutPropertiesLoose(next, ["style", "className"]);

    props = _extends({}, props, {}, rest);

    if (style) {
      props.style = props.style ? _extends({}, props.style || {}, {}, style || {}) : style;
    }

    if (className) {
      props.className = props.className ? props.className + ' ' + className : className;
    }

    if (props.className === '') {
      delete props.className;
    }

    return props;
  }, {});
}

function handlePropGetter(prevProps, userProps, meta) {
  // Handle a lambda, pass it the previous props
  if (typeof userProps === 'function') {
    return handlePropGetter({}, userProps(prevProps, meta));
  } // Handle an array, merge each item as separate props


  if (Array.isArray(userProps)) {
    return mergeProps.apply(void 0, [prevProps].concat(userProps));
  } // Handle an object by default, merge the two objects


  return mergeProps(prevProps, userProps);
}

var makePropGetter = function makePropGetter(hooks, meta) {
  if (meta === void 0) {
    meta = {};
  }

  return function (userProps) {
    if (userProps === void 0) {
      userProps = {};
    }

    return [].concat(hooks, [userProps]).reduce(function (prev, next) {
      return handlePropGetter(prev, next, _extends({}, meta, {
        userProps: userProps
      }));
    }, {});
  };
};
var reduceHooks = function reduceHooks(hooks, initial, meta, allowUndefined) {
  if (meta === void 0) {
    meta = {};
  }

  return hooks.reduce(function (prev, next) {
    var nextValue = next(prev, meta);

    if (process.env.NODE_ENV !== 'production') {
      if (!allowUndefined && typeof nextValue === 'undefined') {
        console.info(next);
        throw new Error('React Table: A reducer hook ☝️ just returned undefined! This is not allowed.');
      }
    }

    return nextValue;
  }, initial);
};
var loopHooks = function loopHooks(hooks, context, meta) {
  if (meta === void 0) {
    meta = {};
  }

  return hooks.forEach(function (hook) {
    var nextValue = hook(context, meta);

    if (process.env.NODE_ENV !== 'production') {
      if (typeof nextValue !== 'undefined') {
        console.info(hook, nextValue);
        throw new Error('React Table: A loop-type hook ☝️ just returned a value! This is not allowed.');
      }
    }
  });
};
function ensurePluginOrder(plugins, befores, pluginName, afters) {
  if (process.env.NODE_ENV !== 'production' && afters) {
    throw new Error("Defining plugins in the \"after\" section of ensurePluginOrder is no longer supported (see plugin " + pluginName + ")");
  }

  var pluginIndex = plugins.findIndex(function (plugin) {
    return plugin.pluginName === pluginName;
  });

  if (pluginIndex === -1) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error("The plugin \"" + pluginName + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + pluginName + ".pluginName = '" + pluginName + "'\n");
    }
  }

  befores.forEach(function (before) {
    var beforeIndex = plugins.findIndex(function (plugin) {
      return plugin.pluginName === before;
    });

    if (beforeIndex > -1 && beforeIndex > pluginIndex) {
      if (process.env.NODE_ENV !== 'production') {
        throw new Error("React Table: The " + pluginName + " plugin hook must be placed after the " + before + " plugin hook!");
      }
    }
  });
}
function functionalUpdate(updater, old) {
  return typeof updater === 'function' ? updater(old) : updater;
}
function useGetLatest(obj) {
  var ref = React.useRef();
  ref.current = obj;
  return React.useCallback(function () {
    return ref.current;
  }, []);
} // SSR has issues with useLayoutEffect still, so use useEffect during SSR

var safeUseLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;
function useMountedLayoutEffect(fn, deps) {
  var mountedRef = React.useRef(false);
  safeUseLayoutEffect(function () {
    if (mountedRef.current) {
      fn();
    }

    mountedRef.current = true; // eslint-disable-next-line
  }, deps);
}
function useAsyncDebounce(defaultFn, defaultWait) {
  if (defaultWait === void 0) {
    defaultWait = 0;
  }

  var debounceRef = React.useRef({});
  var getDefaultFn = useGetLatest(defaultFn);
  var getDefaultWait = useGetLatest(defaultWait);
  return React.useCallback(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var _len2,
          args,
          _key2,
          _args2 = arguments;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = _args2[_key2];
              }

              if (!debounceRef.current.promise) {
                debounceRef.current.promise = new Promise(function (resolve, reject) {
                  debounceRef.current.resolve = resolve;
                  debounceRef.current.reject = reject;
                });
              }

              if (debounceRef.current.timeout) {
                clearTimeout(debounceRef.current.timeout);
              }

              debounceRef.current.timeout = setTimeout(
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        delete debounceRef.current.timeout;
                        _context.prev = 1;
                        _context.t0 = debounceRef.current;
                        _context.next = 5;
                        return getDefaultFn().apply(void 0, args);

                      case 5:
                        _context.t1 = _context.sent;

                        _context.t0.resolve.call(_context.t0, _context.t1);

                        _context.next = 12;
                        break;

                      case 9:
                        _context.prev = 9;
                        _context.t2 = _context["catch"](1);
                        debounceRef.current.reject(_context.t2);

                      case 12:
                        _context.prev = 12;
                        delete debounceRef.current.promise;
                        return _context.finish(12);

                      case 15:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[1, 9, 12, 15]]);
              })), getDefaultWait());
              return _context2.abrupt("return", debounceRef.current.promise);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }(), [getDefaultFn, getDefaultWait]);
}
function makeRenderer(instance, column, meta) {
  if (meta === void 0) {
    meta = {};
  }

  return function (type, userProps) {
    if (userProps === void 0) {
      userProps = {};
    }

    var Comp = typeof type === 'string' ? column[type] : type;

    if (typeof Comp === 'undefined') {
      console.info(column);
      throw new Error(renderErr);
    }

    return flexRender(Comp, _extends({}, instance, {
      column: column
    }, meta, {}, userProps));
  };
}
function flexRender(Comp, props) {
  return isReactComponent(Comp) ? React.createElement(Comp, props) : Comp;
}

function isClassComponent(component) {
  return typeof component === 'function' && !!function () {
    var proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  }();
}

function isFunctionComponent(component) {
  return typeof component === 'function';
}

function isExoticComponent(component) {
  return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
}

function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component) || isExoticComponent(component);
}

function linkColumnStructure(columns, parent, depth) {
  if (depth === void 0) {
    depth = 0;
  }

  return columns.map(function (column) {
    column = _extends({}, column, {
      parent: parent,
      depth: depth
    });
    assignColumnAccessor(column);

    if (column.columns) {
      column.columns = linkColumnStructure(column.columns, column, depth + 1);
    }

    return column;
  });
}
function flattenColumns(columns) {
  return flattenBy(columns, 'columns');
}
function assignColumnAccessor(column) {
  // First check for string accessor
  var id = column.id,
      accessor = column.accessor,
      Header = column.Header;

  if (typeof accessor === 'string') {
    id = id || accessor;
    var accessorPath = accessor.split('.');

    accessor = function accessor(row) {
      return getBy(row, accessorPath);
    };
  }

  if (!id && typeof Header === 'string' && Header) {
    id = Header;
  }

  if (!id && column.columns) {
    console.error(column);
    throw new Error('A column ID (or unique "Header" value) is required!');
  }

  if (!id) {
    console.error(column);
    throw new Error('A column ID (or string accessor) is required!');
  }

  Object.assign(column, {
    id: id,
    accessor: accessor
  });
  return column;
} // Find the depth of the columns

function dedupeBy(arr, fn) {
  return [].concat(arr).reverse().filter(function (d, i, all) {
    return all.findIndex(function (dd) {
      return fn(dd) === fn(d);
    }) === i;
  }).reverse();
}
function decorateColumn(column, userDefaultColumn) {
  if (!userDefaultColumn) {
    throw new Error();
  }

  Object.assign(column, _extends({
    // Make sure there is a fallback header, just in case
    Header: function Header() {
      return React.createElement(React.Fragment, null, "\xA0");
    },
    Footer: function Footer() {
      return React.createElement(React.Fragment, null, "\xA0");
    }
  }, defaultColumn, {}, userDefaultColumn, {}, column));
  return column;
} // Build the header groups from the bottom up

function makeHeaderGroups(allColumns, defaultColumn) {
  var headerGroups = [];
  var scanColumns = allColumns;
  var uid = 0;

  var getUID = function getUID() {
    return uid++;
  };

  var _loop = function _loop() {
    // The header group we are creating
    var headerGroup = {
      headers: []
    }; // The parent columns we're going to scan next

    var parentColumns = [];
    var hasParents = scanColumns.some(function (d) {
      return d.parent;
    }); // Scan each column for parents

    scanColumns.forEach(function (column) {
      // What is the latest (last) parent column?
      var latestParentColumn = [].concat(parentColumns).reverse()[0];
      var newParent;

      if (hasParents) {
        // If the column has a parent, add it if necessary
        if (column.parent) {
          newParent = _extends({}, column.parent, {
            originalId: column.parent.id,
            id: column.parent.id + "_" + getUID(),
            headers: [column]
          });
        } else {
          // If other columns have parents, we'll need to add a place holder if necessary
          var originalId = column.id + "_placeholder";
          newParent = decorateColumn({
            originalId: originalId,
            id: column.id + "_placeholder_" + getUID(),
            placeholderOf: column,
            headers: [column]
          }, defaultColumn);
        } // If the resulting parent columns are the same, just add
        // the column and increment the header span


        if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) {
          latestParentColumn.headers.push(column);
        } else {
          parentColumns.push(newParent);
        }
      }

      headerGroup.headers.push(column);
    });
    headerGroups.push(headerGroup); // Start scanning the parent columns

    scanColumns = parentColumns;
  };

  while (scanColumns.length) {
    _loop();
  }

  return headerGroups.reverse();
}
var pathObjCache = new Map();
function getBy(obj, path, def) {
  if (!path) {
    return obj;
  }

  var cacheKey = typeof path === 'function' ? path : JSON.stringify(path);

  var pathObj = pathObjCache.get(cacheKey) || function () {
    var pathObj = makePathArray(path);
    pathObjCache.set(cacheKey, pathObj);
    return pathObj;
  }();

  var val;

  try {
    val = pathObj.reduce(function (cursor, pathPart) {
      return cursor[pathPart];
    }, obj);
  } catch (e) {// continue regardless of error
  }

  return typeof val !== 'undefined' ? val : def;
}
function getFirstDefined() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  for (var i = 0; i < args.length; i += 1) {
    if (typeof args[i] !== 'undefined') {
      return args[i];
    }
  }
}
function isFunction(a) {
  if (typeof a === 'function') {
    return a;
  }
}
function flattenBy(arr, key) {
  var flat = [];

  var recurse = function recurse(arr) {
    arr.forEach(function (d) {
      if (!d[key]) {
        flat.push(d);
      } else {
        recurse(d[key]);
      }
    });
  };

  recurse(arr);
  return flat;
}
function expandRows(rows, _ref) {
  var manualExpandedKey = _ref.manualExpandedKey,
      expanded = _ref.expanded,
      _ref$expandSubRows = _ref.expandSubRows,
      expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
  var expandedRows = [];

  var handleRow = function handleRow(row) {
    row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
    row.canExpand = row.subRows && !!row.subRows.length;
    expandedRows.push(row);

    if (expandSubRows && row.subRows && row.subRows.length && row.isExpanded) {
      row.subRows.forEach(handleRow);
    }
  };

  rows.forEach(handleRow);
  return expandedRows;
}
function getFilterMethod(filter, userFilterTypes, filterTypes) {
  return isFunction(filter) || userFilterTypes[filter] || filterTypes[filter] || filterTypes.text;
}
function shouldAutoRemoveFilter(autoRemove, value, column) {
  return autoRemove ? autoRemove(value, column) : typeof value === 'undefined';
}
function unpreparedAccessWarning() {
  throw new Error('React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.');
} //

var reOpenBracket = /\[/g;
var reCloseBracket = /\]/g;

function makePathArray(obj) {
  return flattenDeep(obj) // remove all periods in parts
  .map(function (d) {
    return String(d).replace('.', '_');
  }) // join parts using period
  .join('.') // replace brackets with periods
  .replace(reOpenBracket, '.').replace(reCloseBracket, '') // split it back out on periods
  .split('.');
}

function flattenDeep(arr, newArr) {
  if (newArr === void 0) {
    newArr = [];
  }

  if (!Array.isArray(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i += 1) {
      flattenDeep(arr[i], newArr);
    }
  }

  return newArr;
}

var defaultGetTableProps = function defaultGetTableProps(props) {
  return _extends({
    role: 'table'
  }, props);
};

var defaultGetTableBodyProps = function defaultGetTableBodyProps(props) {
  return _extends({
    role: 'rowgroup'
  }, props);
};

var defaultGetHeaderProps = function defaultGetHeaderProps(props, _ref) {
  var column = _ref.column;
  return _extends({
    key: "header_" + column.id,
    colSpan: column.totalVisibleHeaderCount,
    role: 'columnheader'
  }, props);
};

var defaultGetFooterProps = function defaultGetFooterProps(props, _ref2) {
  var column = _ref2.column;
  return _extends({
    key: "footer_" + column.id,
    colSpan: column.totalVisibleHeaderCount
  }, props);
};

var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps(props, _ref3) {
  var index = _ref3.index;
  return _extends({
    key: "headerGroup_" + index,
    role: 'row'
  }, props);
};

var defaultGetFooterGroupProps = function defaultGetFooterGroupProps(props, _ref4) {
  var index = _ref4.index;
  return _extends({
    key: "footerGroup_" + index
  }, props);
};

var defaultGetRowProps = function defaultGetRowProps(props, _ref5) {
  var row = _ref5.row;
  return _extends({
    key: "row_" + row.id,
    role: 'row'
  }, props);
};

var defaultGetCellProps = function defaultGetCellProps(props, _ref6) {
  var cell = _ref6.cell;
  return _extends({
    key: "cell_" + cell.row.id + "_" + cell.column.id,
    role: 'cell'
  }, props);
};

function makeDefaultPluginHooks() {
  return {
    useOptions: [],
    stateReducers: [],
    useControlledState: [],
    columns: [],
    columnsDeps: [],
    allColumns: [],
    allColumnsDeps: [],
    accessValue: [],
    materializedColumns: [],
    materializedColumnsDeps: [],
    useInstanceAfterData: [],
    visibleColumns: [],
    visibleColumnsDeps: [],
    headerGroups: [],
    headerGroupsDeps: [],
    useInstanceBeforeDimensions: [],
    useInstance: [],
    prepareRow: [],
    getTableProps: [defaultGetTableProps],
    getTableBodyProps: [defaultGetTableBodyProps],
    getHeaderGroupProps: [defaultGetHeaderGroupProps],
    getFooterGroupProps: [defaultGetFooterGroupProps],
    getHeaderProps: [defaultGetHeaderProps],
    getFooterProps: [defaultGetFooterProps],
    getRowProps: [defaultGetRowProps],
    getCellProps: [defaultGetCellProps],
    useFinalInstance: []
  };
}

actions.resetHiddenColumns = 'resetHiddenColumns';
actions.toggleHideColumn = 'toggleHideColumn';
actions.setHiddenColumns = 'setHiddenColumns';
actions.toggleHideAllColumns = 'toggleHideAllColumns';
var useColumnVisibility = function useColumnVisibility(hooks) {
  hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
  hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
  hooks.stateReducers.push(reducer);
  hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
  hooks.headerGroupsDeps.push(function (deps, _ref) {
    var instance = _ref.instance;
    return [].concat(deps, [instance.state.hiddenColumns]);
  });
  hooks.useInstance.push(useInstance);
};
useColumnVisibility.pluginName = 'useColumnVisibility';

var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps(props, _ref2) {
  var column = _ref2.column;
  return [props, {
    onChange: function onChange(e) {
      column.toggleHidden(!e.target.checked);
    },
    style: {
      cursor: 'pointer'
    },
    checked: column.isVisible,
    title: 'Toggle Column Visible'
  }];
};

var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps(props, _ref3) {
  var instance = _ref3.instance;
  return [props, {
    onChange: function onChange(e) {
      instance.toggleHideAllColumns(!e.target.checked);
    },
    style: {
      cursor: 'pointer'
    },
    checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
    title: 'Toggle All Columns Hidden',
    indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
  }];
};

function reducer(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      hiddenColumns: []
    }, state);
  }

  if (action.type === actions.resetHiddenColumns) {
    return _extends({}, state, {
      hiddenColumns: instance.initialState.hiddenColumns || []
    });
  }

  if (action.type === actions.toggleHideColumn) {
    var should = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.includes(action.columnId);
    var hiddenColumns = should ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function (d) {
      return d !== action.columnId;
    });
    return _extends({}, state, {
      hiddenColumns: hiddenColumns
    });
  }

  if (action.type === actions.setHiddenColumns) {
    return _extends({}, state, {
      hiddenColumns: functionalUpdate(action.value, state.hiddenColumns)
    });
  }

  if (action.type === actions.toggleHideAllColumns) {
    var shouldAll = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.length;
    return _extends({}, state, {
      hiddenColumns: shouldAll ? instance.allColumns.map(function (d) {
        return d.id;
      }) : []
    });
  }
}

function useInstanceBeforeDimensions(instance) {
  var headers = instance.headers,
      hiddenColumns = instance.state.hiddenColumns;
  var isMountedRef = React.useRef(false);

  if (!isMountedRef.current) ;

  var handleColumn = function handleColumn(column, parentVisible) {
    column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
    var totalVisibleHeaderCount = 0;

    if (column.headers && column.headers.length) {
      column.headers.forEach(function (subColumn) {
        return totalVisibleHeaderCount += handleColumn(subColumn, column.isVisible);
      });
    } else {
      totalVisibleHeaderCount = column.isVisible ? 1 : 0;
    }

    column.totalVisibleHeaderCount = totalVisibleHeaderCount;
    return totalVisibleHeaderCount;
  };

  var totalVisibleHeaderCount = 0;
  headers.forEach(function (subHeader) {
    return totalVisibleHeaderCount += handleColumn(subHeader, true);
  });
}

function useInstance(instance) {
  var flatHeaders = instance.flatHeaders,
      dispatch = instance.dispatch,
      allColumns = instance.allColumns,
      getHooks = instance.getHooks,
      hiddenColumns = instance.state.hiddenColumns;
  var getInstance = useGetLatest(instance);
  var allColumnsHidden = allColumns.length === hiddenColumns.length;
  var toggleHideColumn = React.useCallback(function (columnId, value) {
    return dispatch({
      type: actions.toggleHideColumn,
      columnId: columnId,
      value: value
    });
  }, [dispatch]);
  var setHiddenColumns = React.useCallback(function (value) {
    return dispatch({
      type: actions.setHiddenColumns,
      value: value
    });
  }, [dispatch]);
  var toggleHideAllColumns = React.useCallback(function (value) {
    return dispatch({
      type: actions.toggleHideAllColumns,
      value: value
    });
  }, [dispatch]);
  var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, {
    instance: getInstance()
  });
  flatHeaders.forEach(function (column) {
    column.toggleHidden = function (value) {
      dispatch({
        type: actions.toggleHideColumn,
        columnId: column.id,
        value: value
      });
    };

    column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
      instance: getInstance(),
      column: column
    });
  });
  Object.assign(instance, {
    allColumnsHidden: allColumnsHidden,
    toggleHideColumn: toggleHideColumn,
    setHiddenColumns: setHiddenColumns,
    toggleHideAllColumns: toggleHideAllColumns,
    getToggleHideAllColumnsProps: getToggleHideAllColumnsProps
  });
}

var defaultInitialState = {};
var defaultColumnInstance = {};

var defaultReducer = function defaultReducer(state, action, prevState) {
  return state;
};

var defaultGetSubRows = function defaultGetSubRows(row, index) {
  return row.subRows || [];
};

var defaultGetRowId = function defaultGetRowId(row, index, parent) {
  return "" + (parent ? [parent.id, index].join('.') : index);
};

var defaultUseControlledState = function defaultUseControlledState(d) {
  return d;
};

function applyDefaults(props) {
  var _props$initialState = props.initialState,
      initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState,
      _props$defaultColumn = props.defaultColumn,
      defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn,
      _props$getSubRows = props.getSubRows,
      getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows,
      _props$getRowId = props.getRowId,
      getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
      _props$stateReducer = props.stateReducer,
      stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer,
      _props$useControlledS = props.useControlledState,
      useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS,
      rest = _objectWithoutPropertiesLoose(props, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);

  return _extends({}, rest, {
    initialState: initialState,
    defaultColumn: defaultColumn,
    getSubRows: getSubRows,
    getRowId: getRowId,
    stateReducer: stateReducer,
    useControlledState: useControlledState
  });
}

var useTable = function useTable(props) {
  for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    plugins[_key - 1] = arguments[_key];
  }

  // Apply default props
  props = applyDefaults(props); // Add core plugins

  plugins = [useColumnVisibility].concat(plugins); // Create the table instance

  var instanceRef = React.useRef({}); // Create a getter for the instance (helps avoid a lot of potential memory leaks)

  var getInstance = useGetLatest(instanceRef.current); // Assign the props, plugins and hooks to the instance

  Object.assign(getInstance(), _extends({}, props, {
    plugins: plugins,
    hooks: makeDefaultPluginHooks()
  })); // Allow plugins to register hooks as early as possible

  plugins.filter(Boolean).forEach(function (plugin) {
    plugin(getInstance().hooks);
  }); // Consume all hooks and make a getter for them

  var getHooks = useGetLatest(getInstance().hooks);
  getInstance().getHooks = getHooks;
  delete getInstance().hooks; // Allow useOptions hooks to modify the options coming into the table

  Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));

  var _getInstance = getInstance(),
      data = _getInstance.data,
      userColumns = _getInstance.columns,
      initialState = _getInstance.initialState,
      defaultColumn = _getInstance.defaultColumn,
      getSubRows = _getInstance.getSubRows,
      getRowId = _getInstance.getRowId,
      stateReducer = _getInstance.stateReducer,
      useControlledState = _getInstance.useControlledState; // Setup user reducer ref


  var getStateReducer = useGetLatest(stateReducer); // Build the reducer

  var reducer = React.useCallback(function (state, action) {
    // Detect invalid actions
    if (!action.type) {
      console.info({
        action: action
      });
      throw new Error('Unknown Action 👆');
    } // Reduce the state from all plugin reducers


    return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function (s, handler) {
      return handler(s, action, state, getInstance()) || s;
    }, state);
  }, [getHooks, getStateReducer, getInstance]); // Start the reducer

  var _React$useReducer = React.useReducer(reducer, undefined, function () {
    return reducer(initialState, {
      type: actions.init
    });
  }),
      reducerState = _React$useReducer[0],
      dispatch = _React$useReducer[1]; // Allow the user to control the final state with hooks


  var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, {
    instance: getInstance()
  });
  Object.assign(getInstance(), {
    state: state,
    dispatch: dispatch
  }); // Decorate All the columns

  var columns = React.useMemo(function () {
    return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
      instance: getInstance()
    }));
  }, [getHooks, getInstance, userColumns].concat(reduceHooks(getHooks().columnsDeps, [], {
    instance: getInstance()
  })));
  getInstance().columns = columns; // Get the flat list of all columns and allow hooks to decorate
  // those columns (and trigger this memoization via deps)

  var allColumns = React.useMemo(function () {
    return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
      instance: getInstance()
    }).map(assignColumnAccessor);
  }, [columns, getHooks, getInstance].concat(reduceHooks(getHooks().allColumnsDeps, [], {
    instance: getInstance()
  })));
  getInstance().allColumns = allColumns; // Access the row model using initial columns

  var coreDataModel = React.useMemo(function () {
    var rows = [];
    var flatRows = [];
    var rowsById = {};
    var allColumnsQueue = [].concat(allColumns);

    while (allColumnsQueue.length) {
      var column = allColumnsQueue.shift();
      accessRowsForColumn({
        data: data,
        rows: rows,
        flatRows: flatRows,
        rowsById: rowsById,
        column: column,
        getRowId: getRowId,
        getSubRows: getSubRows,
        accessValueHooks: getHooks().accessValue,
        getInstance: getInstance
      });
    }

    return {
      rows: rows,
      flatRows: flatRows,
      rowsById: rowsById
    };
  }, [allColumns, data, getRowId, getSubRows, getHooks, getInstance]); // Allow materialized columns to also access data

  var _React$useMemo = React.useMemo(function () {
    var rows = coreDataModel.rows,
        flatRows = coreDataModel.flatRows,
        rowsById = coreDataModel.rowsById;
    var materializedColumns = reduceHooks(getHooks().materializedColumns, [], {
      instance: getInstance()
    });
    materializedColumns.forEach(function (d) {
      return assignColumnAccessor(d);
    });
    var materializedColumnsQueue = [].concat(materializedColumns);

    while (materializedColumnsQueue.length) {
      var column = materializedColumnsQueue.shift();
      accessRowsForColumn({
        data: data,
        rows: rows,
        flatRows: flatRows,
        rowsById: rowsById,
        column: column,
        getRowId: getRowId,
        getSubRows: getSubRows,
        accessValueHooks: getHooks().accessValue,
        getInstance: getInstance
      });
    }

    return [rows, flatRows, rowsById, materializedColumns];
  }, [coreDataModel, getHooks, getInstance, data, getRowId, getSubRows].concat(reduceHooks(getHooks().materializedColumnsDeps, [], {
    instance: getInstance()
  }))),
      rows = _React$useMemo[0],
      flatRows = _React$useMemo[1],
      rowsById = _React$useMemo[2],
      materializedColumns = _React$useMemo[3];

  Object.assign(getInstance(), {
    rows: rows,
    flatRows: flatRows,
    rowsById: rowsById,
    materializedColumns: materializedColumns
  });
  loopHooks(getHooks().useInstanceAfterData, getInstance()); // Combine new materialized columns with all columns (dedupe prefers later columns)

  allColumns = React.useMemo(function () {
    return dedupeBy([].concat(allColumns, materializedColumns), function (d) {
      return d.id;
    });
  }, [allColumns, materializedColumns]);
  getInstance().allColumns = allColumns; // Get the flat list of all columns AFTER the rows
  // have been access, and allow hooks to decorate
  // those columns (and trigger this memoization via deps)

  var visibleColumns = React.useMemo(function () {
    return reduceHooks(getHooks().visibleColumns, allColumns, {
      instance: getInstance()
    }).map(function (d) {
      return decorateColumn(d, defaultColumn);
    });
  }, [getHooks, allColumns, getInstance, defaultColumn].concat(reduceHooks(getHooks().visibleColumnsDeps, [], {
    instance: getInstance()
  }))); // Combine new visible columns with all columns (dedupe prefers later columns)

  allColumns = React.useMemo(function () {
    return dedupeBy([].concat(allColumns, visibleColumns), function (d) {
      return d.id;
    });
  }, [allColumns, visibleColumns]);
  getInstance().allColumns = allColumns; // Make the headerGroups

  var headerGroups = React.useMemo(function () {
    return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
  }, [getHooks, visibleColumns, defaultColumn, getInstance].concat(reduceHooks(getHooks().headerGroupsDeps, [], {
    instance: getInstance()
  })));
  getInstance().headerGroups = headerGroups; // Get the first level of headers

  var headers = React.useMemo(function () {
    return headerGroups.length ? headerGroups[0].headers : [];
  }, [headerGroups]);
  getInstance().headers = headers; // Provide a flat header list for utilities

  getInstance().flatHeaders = headerGroups.reduce(function (all, headerGroup) {
    return [].concat(all, headerGroup.headers);
  }, []);
  loopHooks(getHooks().useInstanceBeforeDimensions, getInstance()); // Filter columns down to visible ones

  var visibleColumnsDep = visibleColumns.filter(function (d) {
    return d.isVisible;
  }).map(function (d) {
    return d.id;
  }).sort().join('_');
  visibleColumns = React.useMemo(function () {
    return visibleColumns.filter(function (d) {
      return d.isVisible;
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [visibleColumns, visibleColumnsDep]);
  getInstance().visibleColumns = visibleColumns; // Header Visibility is needed by this point

  var _calculateHeaderWidth = calculateHeaderWidths(headers),
      totalColumnsMinWidth = _calculateHeaderWidth[0],
      totalColumnsWidth = _calculateHeaderWidth[1],
      totalColumnsMaxWidth = _calculateHeaderWidth[2];

  getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
  getInstance().totalColumnsWidth = totalColumnsWidth;
  getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
  loopHooks(getHooks().useInstance, getInstance()) // Each materialized header needs to be assigned a render function and other
  // prop getter properties here.
  ;
  [].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function (column) {
    // Give columns/headers rendering power
    column.render = makeRenderer(getInstance(), column); // Give columns/headers a default getHeaderProps

    column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
      instance: getInstance(),
      column: column
    }); // Give columns/headers a default getFooterProps

    column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
      instance: getInstance(),
      column: column
    });
  });
  getInstance().headerGroups = getInstance().headerGroups.filter(function (headerGroup, i) {
    // Filter out any headers and headerGroups that don't have visible columns
    headerGroup.headers = headerGroup.headers.filter(function (column) {
      var recurse = function recurse(headers) {
        return headers.filter(function (column) {
          if (column.headers) {
            return recurse(column.headers);
          }

          return column.isVisible;
        }).length;
      };

      if (column.headers) {
        return recurse(column.headers);
      }

      return column.isVisible;
    }); // Give headerGroups getRowProps

    if (headerGroup.headers.length) {
      headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
        instance: getInstance(),
        headerGroup: headerGroup,
        index: i
      });
      headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
        instance: getInstance(),
        headerGroup: headerGroup,
        index: i
      });
      return true;
    }

    return false;
  });
  getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse(); // The prepareRow function is absolutely necessary and MUST be called on
  // any rows the user wishes to be displayed.

  getInstance().prepareRow = React.useCallback(function (row) {
    row.getRowProps = makePropGetter(getHooks().getRowProps, {
      instance: getInstance(),
      row: row
    }); // Build the visible cells for each row

    row.allCells = allColumns.map(function (column) {
      var cell = {
        column: column,
        row: row,
        value: row.values[column.id]
      }; // Give each cell a getCellProps base

      cell.getCellProps = makePropGetter(getHooks().getCellProps, {
        instance: getInstance(),
        cell: cell
      }); // Give each cell a renderer function (supports multiple renderers)

      cell.render = makeRenderer(getInstance(), column, {
        row: row,
        cell: cell
      });
      return cell;
    });
    row.cells = visibleColumns.map(function (column) {
      return row.allCells.find(function (cell) {
        return cell.column.id === column.id;
      });
    }); // need to apply any row specific hooks (useExpanded requires this)

    loopHooks(getHooks().prepareRow, row, {
      instance: getInstance()
    });
  }, [getHooks, getInstance, allColumns, visibleColumns]);
  getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
    instance: getInstance()
  });
  getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
    instance: getInstance()
  });
  loopHooks(getHooks().useFinalInstance, getInstance());
  return getInstance();
};

function calculateHeaderWidths(headers, left) {
  if (left === void 0) {
    left = 0;
  }

  var sumTotalMinWidth = 0;
  var sumTotalWidth = 0;
  var sumTotalMaxWidth = 0;
  var sumTotalFlexWidth = 0;
  headers.forEach(function (header) {
    var subHeaders = header.headers;
    header.totalLeft = left;

    if (subHeaders && subHeaders.length) {
      var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left),
          totalMinWidth = _calculateHeaderWidth2[0],
          totalWidth = _calculateHeaderWidth2[1],
          totalMaxWidth = _calculateHeaderWidth2[2],
          totalFlexWidth = _calculateHeaderWidth2[3];

      header.totalMinWidth = totalMinWidth;
      header.totalWidth = totalWidth;
      header.totalMaxWidth = totalMaxWidth;
      header.totalFlexWidth = totalFlexWidth;
    } else {
      header.totalMinWidth = header.minWidth;
      header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
      header.totalMaxWidth = header.maxWidth;
      header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
    }

    if (header.isVisible) {
      left += header.totalWidth;
      sumTotalMinWidth += header.totalMinWidth;
      sumTotalWidth += header.totalWidth;
      sumTotalMaxWidth += header.totalMaxWidth;
      sumTotalFlexWidth += header.totalFlexWidth;
    }
  });
  return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
}

function accessRowsForColumn(_ref) {
  var data = _ref.data,
      rows = _ref.rows,
      flatRows = _ref.flatRows,
      rowsById = _ref.rowsById,
      column = _ref.column,
      getRowId = _ref.getRowId,
      getSubRows = _ref.getSubRows,
      accessValueHooks = _ref.accessValueHooks,
      getInstance = _ref.getInstance;

  // Access the row's data column-by-column
  // We do it this way so we can incrementally add materialized
  // columns after the first pass and avoid excessive looping
  var accessRow = function accessRow(originalRow, rowIndex, depth, parent, parentRows) {
    if (depth === void 0) {
      depth = 0;
    }

    // Keep the original reference around
    var original = originalRow;
    var id = getRowId(originalRow, rowIndex, parent);
    var row = rowsById[id]; // If the row hasn't been created, let's make it

    if (!row) {
      row = {
        id: id,
        original: original,
        index: rowIndex,
        depth: depth,
        cells: [{}] // This is a dummy cell

      }; // Override common array functions (and the dummy cell's getCellProps function)
      // to show an error if it is accessed without calling prepareRow

      row.cells.map = unpreparedAccessWarning;
      row.cells.filter = unpreparedAccessWarning;
      row.cells.forEach = unpreparedAccessWarning;
      row.cells[0].getCellProps = unpreparedAccessWarning; // Create the cells and values

      row.values = {}; // Push this row into the parentRows array

      parentRows.push(row); // Keep track of every row in a flat array

      flatRows.push(row); // Also keep track of every row by its ID

      rowsById[id] = row; // Get the original subrows

      row.originalSubRows = getSubRows(originalRow, rowIndex); // Then recursively access them

      if (row.originalSubRows) {
        var subRows = [];
        row.originalSubRows.forEach(function (d, i) {
          return accessRow(d, i, depth + 1, row, subRows);
        }); // Keep the new subRows array on the row

        row.subRows = subRows;
      }
    } else if (row.subRows) {
      // If the row exists, then it's already been accessed
      // Keep recursing, but don't worry about passing the
      // accumlator array (those rows already exist)
      row.originalSubRows.forEach(function (d, i) {
        return accessRow(d, i, depth + 1, row);
      });
    } // If the column has an accessor, use it to get a value


    if (column.accessor) {
      row.values[column.id] = column.accessor(originalRow, rowIndex, row);
    } // Allow plugins to manipulate the column value


    row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
      row: row,
      column: column,
      instance: getInstance()
    }, true);
  };

  data.forEach(function (originalRow, rowIndex) {
    return accessRow(originalRow, rowIndex, 0, undefined, rows);
  });
}

actions.resetExpanded = 'resetExpanded';
actions.toggleRowExpanded = 'toggleRowExpanded';
actions.toggleAllRowsExpanded = 'toggleAllRowsExpanded';
var useExpanded = function useExpanded(hooks) {
  hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
  hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
  hooks.stateReducers.push(reducer$1);
  hooks.useInstance.push(useInstance$1);
  hooks.prepareRow.push(prepareRow);
};
useExpanded.pluginName = 'useExpanded';

var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
  var instance = _ref.instance;
  return [props, {
    onClick: function onClick(e) {
      instance.toggleAllRowsExpanded();
    },
    style: {
      cursor: 'pointer'
    },
    title: 'Toggle All Rows Expanded'
  }];
};

var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
  var row = _ref2.row;
  return [props, {
    onClick: function onClick() {
      row.toggleRowExpanded();
    },
    style: {
      cursor: 'pointer'
    },
    title: 'Toggle Row Expanded'
  }];
}; // Reducer


function reducer$1(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      expanded: {}
    }, state);
  }

  if (action.type === actions.resetExpanded) {
    return _extends({}, state, {
      expanded: instance.initialState.expanded || {}
    });
  }

  if (action.type === actions.toggleAllRowsExpanded) {
    var value = action.value;
    var isAllRowsExpanded = instance.isAllRowsExpanded,
        rowsById = instance.rowsById;
    var expandAll = typeof value !== 'undefined' ? value : !isAllRowsExpanded;

    if (expandAll) {
      var expanded = {};
      Object.keys(rowsById).forEach(function (rowId) {
        expanded[rowId] = true;
      });
      return _extends({}, state, {
        expanded: expanded
      });
    }

    return _extends({}, state, {
      expanded: {}
    });
  }

  if (action.type === actions.toggleRowExpanded) {
    var id = action.id,
        setExpanded = action.value;
    var exists = state.expanded[id];
    var shouldExist = typeof setExpanded !== 'undefined' ? setExpanded : !exists;

    if (!exists && shouldExist) {
      var _extends2;

      return _extends({}, state, {
        expanded: _extends({}, state.expanded, (_extends2 = {}, _extends2[id] = true, _extends2))
      });
    } else if (exists && !shouldExist) {
      var _state$expanded = state.expanded,
          _ = _state$expanded[id],
          rest = _objectWithoutPropertiesLoose(_state$expanded, [id].map(_toPropertyKey));

      return _extends({}, state, {
        expanded: rest
      });
    } else {
      return state;
    }
  }
}

function useInstance$1(instance) {
  var data = instance.data,
      rows = instance.rows,
      rowsById = instance.rowsById,
      _instance$manualExpan = instance.manualExpandedKey,
      manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
      _instance$paginateExp = instance.paginateExpandedRows,
      paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
      _instance$expandSubRo = instance.expandSubRows,
      expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
      _instance$autoResetEx = instance.autoResetExpanded,
      autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx,
      getHooks = instance.getHooks,
      plugins = instance.plugins,
      expanded = instance.state.expanded,
      dispatch = instance.dispatch;
  ensurePluginOrder(plugins, ['useSortBy', 'useGroupBy', 'usePivotColumns', 'useGlobalFilter'], 'useExpanded');
  var getAutoResetExpanded = useGetLatest(autoResetExpanded);
  var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);

  if (isAllRowsExpanded) {
    if (Object.keys(rowsById).some(function (id) {
      return !expanded[id];
    })) {
      isAllRowsExpanded = false;
    }
  } // Bypass any effects from firing when this changes


  useMountedLayoutEffect(function () {
    if (getAutoResetExpanded()) {
      dispatch({
        type: actions.resetExpanded
      });
    }
  }, [dispatch, data]);
  var toggleRowExpanded = React.useCallback(function (id, value) {
    dispatch({
      type: actions.toggleRowExpanded,
      id: id,
      value: value
    });
  }, [dispatch]);
  var toggleAllRowsExpanded = React.useCallback(function (value) {
    return dispatch({
      type: actions.toggleAllRowsExpanded,
      value: value
    });
  }, [dispatch]);
  var expandedRows = React.useMemo(function () {
    if (paginateExpandedRows) {
      return expandRows(rows, {
        manualExpandedKey: manualExpandedKey,
        expanded: expanded,
        expandSubRows: expandSubRows
      });
    }

    return rows;
  }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
  var expandedDepth = React.useMemo(function () {
    return findExpandedDepth(expanded);
  }, [expanded]);
  var getInstance = useGetLatest(instance);
  var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
    instance: getInstance()
  });
  Object.assign(instance, {
    preExpandedRows: rows,
    expandedRows: expandedRows,
    rows: expandedRows,
    expandedDepth: expandedDepth,
    isAllRowsExpanded: isAllRowsExpanded,
    toggleRowExpanded: toggleRowExpanded,
    toggleAllRowsExpanded: toggleAllRowsExpanded,
    getToggleAllRowsExpandedProps: getToggleAllRowsExpandedProps
  });
}

function prepareRow(row, _ref3) {
  var getHooks = _ref3.instance.getHooks,
      instance = _ref3.instance;

  row.toggleRowExpanded = function (set) {
    return instance.toggleRowExpanded(row.id, set);
  };

  row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
    instance: instance,
    row: row
  });
}

function findExpandedDepth(expanded) {
  var maxDepth = 0;
  Object.keys(expanded).forEach(function (id) {
    var splitId = id.split('.');
    maxDepth = Math.max(maxDepth, splitId.length);
  });
  return maxDepth;
}

var text = function text(rows, ids, filterValue) {
  rows = rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
    });
  });
  return rows;
};

text.autoRemove = function (val) {
  return !val;
};

var exactText = function exactText(rows, ids, filterValue) {
  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return rowValue !== undefined ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
    });
  });
};

exactText.autoRemove = function (val) {
  return !val;
};

var exactTextCase = function exactTextCase(rows, ids, filterValue) {
  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return rowValue !== undefined ? String(rowValue) === String(filterValue) : true;
    });
  });
};

exactTextCase.autoRemove = function (val) {
  return !val;
};

var includes = function includes(rows, ids, filterValue) {
  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return filterValue.includes(rowValue);
    });
  });
};

includes.autoRemove = function (val) {
  return !val || !val.length;
};

var includesAll = function includesAll(rows, ids, filterValue) {
  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return rowValue && rowValue.length && filterValue.every(function (val) {
        return rowValue.includes(val);
      });
    });
  });
};

includesAll.autoRemove = function (val) {
  return !val || !val.length;
};

var exact = function exact(rows, ids, filterValue) {
  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return rowValue === filterValue;
    });
  });
};

exact.autoRemove = function (val) {
  return typeof val === 'undefined';
};

var equals = function equals(rows, ids, filterValue) {
  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id]; // eslint-disable-next-line eqeqeq

      return rowValue == filterValue;
    });
  });
};

equals.autoRemove = function (val) {
  return val == null;
};

var between = function between(rows, ids, filterValue) {
  var _ref = filterValue || [],
      min = _ref[0],
      max = _ref[1];

  min = typeof min === 'number' ? min : -Infinity;
  max = typeof max === 'number' ? max : Infinity;

  if (min > max) {
    var temp = min;
    min = max;
    max = temp;
  }

  return rows.filter(function (row) {
    return ids.some(function (id) {
      var rowValue = row.values[id];
      return rowValue >= min && rowValue <= max;
    });
  });
};

between.autoRemove = function (val) {
  return !val || typeof val[0] !== 'number' && typeof val[1] !== 'number';
};

var filterTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  text: text,
  exactText: exactText,
  exactTextCase: exactTextCase,
  includes: includes,
  includesAll: includesAll,
  exact: exact,
  equals: equals,
  between: between
});

actions.resetFilters = 'resetFilters';
actions.setFilter = 'setFilter';
actions.setAllFilters = 'setAllFilters';
var useFilters = function useFilters(hooks) {
  hooks.stateReducers.push(reducer$2);
  hooks.useInstance.push(useInstance$2);
};
useFilters.pluginName = 'useFilters';

function reducer$2(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      filters: []
    }, state);
  }

  if (action.type === actions.resetFilters) {
    return _extends({}, state, {
      filters: instance.initialState.filters || []
    });
  }

  if (action.type === actions.setFilter) {
    var columnId = action.columnId,
        filterValue = action.filterValue;
    var allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes;
    var column = allColumns.find(function (d) {
      return d.id === columnId;
    });

    if (!column) {
      throw new Error("React-Table: Could not find a column with id: " + columnId);
    }

    var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
    var previousfilter = state.filters.find(function (d) {
      return d.id === columnId;
    });
    var newFilter = functionalUpdate(filterValue, previousfilter && previousfilter.value); //

    if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter, column)) {
      return _extends({}, state, {
        filters: state.filters.filter(function (d) {
          return d.id !== columnId;
        })
      });
    }

    if (previousfilter) {
      return _extends({}, state, {
        filters: state.filters.map(function (d) {
          if (d.id === columnId) {
            return {
              id: columnId,
              value: newFilter
            };
          }

          return d;
        })
      });
    }

    return _extends({}, state, {
      filters: [].concat(state.filters, [{
        id: columnId,
        value: newFilter
      }])
    });
  }

  if (action.type === actions.setAllFilters) {
    var filters = action.filters;
    var _allColumns = instance.allColumns,
        _userFilterTypes = instance.filterTypes;
    return _extends({}, state, {
      // Filter out undefined values
      filters: functionalUpdate(filters, state.filters).filter(function (filter) {
        var column = _allColumns.find(function (d) {
          return d.id === filter.id;
        });

        var filterMethod = getFilterMethod(column.filter, _userFilterTypes || {}, filterTypes);

        if (shouldAutoRemoveFilter(filterMethod.autoRemove, filter.value, column)) {
          return false;
        }

        return true;
      })
    });
  }
}

function useInstance$2(instance) {
  var data = instance.data,
      rows = instance.rows,
      flatRows = instance.flatRows,
      rowsById = instance.rowsById,
      allColumns = instance.allColumns,
      userFilterTypes = instance.filterTypes,
      manualFilters = instance.manualFilters,
      _instance$defaultCanF = instance.defaultCanFilter,
      defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF,
      disableFilters = instance.disableFilters,
      filters = instance.state.filters,
      dispatch = instance.dispatch,
      _instance$autoResetFi = instance.autoResetFilters,
      autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
  var setFilter = React.useCallback(function (columnId, filterValue) {
    dispatch({
      type: actions.setFilter,
      columnId: columnId,
      filterValue: filterValue
    });
  }, [dispatch]);
  var setAllFilters = React.useCallback(function (filters) {
    dispatch({
      type: actions.setAllFilters,
      filters: filters
    });
  }, [dispatch]);
  allColumns.forEach(function (column) {
    var id = column.id,
        accessor = column.accessor,
        columnDefaultCanFilter = column.defaultCanFilter,
        columnDisableFilters = column.disableFilters; // Determine if a column is filterable

    column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : undefined, disableFilters === true ? false : undefined, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false); // Provide the column a way of updating the filter value

    column.setFilter = function (val) {
      return setFilter(column.id, val);
    }; // Provide the current filter value to the column for
    // convenience


    var found = filters.find(function (d) {
      return d.id === id;
    });
    column.filterValue = found && found.value;
  });

  var _React$useMemo = React.useMemo(function () {
    if (manualFilters || !filters.length) {
      return [rows, flatRows, rowsById];
    }

    var filteredFlatRows = [];
    var filteredRowsById = {}; // Filters top level and nested rows

    var filterRows = function filterRows(rows, depth) {
      if (depth === void 0) {
        depth = 0;
      }

      var filteredRows = rows;
      filteredRows = filters.reduce(function (filteredSoFar, _ref) {
        var columnId = _ref.id,
            filterValue = _ref.value;
        // Find the filters column
        var column = allColumns.find(function (d) {
          return d.id === columnId;
        });

        if (!column) {
          return filteredSoFar;
        }

        if (depth === 0) {
          column.preFilteredRows = filteredSoFar;
        }

        var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);

        if (!filterMethod) {
          console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
          return filteredSoFar;
        } // Pass the rows, id, filterValue and column to the filterMethod
        // to get the filtered rows back


        column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
        return column.filteredRows;
      }, rows); // Apply the filter to any subRows
      // We technically could do this recursively in the above loop,
      // but that would severely hinder the API for the user, since they
      // would be required to do that recursion in some scenarios

      filteredRows = filteredRows.map(function (row) {
        filteredFlatRows.push(row);
        filteredRowsById[row.id] = row;

        if (!row.subRows) {
          return row;
        }

        return _extends({}, row, {
          subRows: row.subRows && row.subRows.length > 0 ? filterRows(row.subRows, depth + 1) : row.subRows
        });
      });
      return filteredRows;
    };

    return [filterRows(rows), filteredFlatRows, filteredRowsById];
  }, [manualFilters, filters, rows, flatRows, rowsById, allColumns, userFilterTypes]),
      filteredRows = _React$useMemo[0],
      filteredFlatRows = _React$useMemo[1],
      filteredRowsById = _React$useMemo[2];

  React.useMemo(function () {
    // Now that each filtered column has it's partially filtered rows,
    // lets assign the final filtered rows to all of the other columns
    var nonFilteredColumns = allColumns.filter(function (column) {
      return !filters.find(function (d) {
        return d.id === column.id;
      });
    }); // This essentially enables faceted filter options to be built easily
    // using every column's preFilteredRows value

    nonFilteredColumns.forEach(function (column) {
      column.preFilteredRows = filteredRows;
      column.filteredRows = filteredRows;
    });
  }, [filteredRows, filters, allColumns]);
  var getAutoResetFilters = useGetLatest(autoResetFilters);
  useMountedLayoutEffect(function () {
    if (getAutoResetFilters()) {
      dispatch({
        type: actions.resetFilters
      });
    }
  }, [dispatch, manualFilters ? null : data]);
  Object.assign(instance, {
    preFilteredRows: rows,
    preFilteredFlatRows: flatRows,
    preFilteredRowsById: rowsById,
    filteredRows: filteredRows,
    filteredFlatRows: filteredFlatRows,
    filteredRowsById: filteredRowsById,
    rows: filteredRows,
    flatRows: filteredFlatRows,
    rowsById: filteredRowsById,
    setFilter: setFilter,
    setAllFilters: setAllFilters
  });
}

actions.resetGlobalFilter = 'resetGlobalFilter';
actions.setGlobalFilter = 'setGlobalFilter';
var useGlobalFilter = function useGlobalFilter(hooks) {
  hooks.stateReducers.push(reducer$3);
  hooks.useInstance.push(useInstance$3);
};
useGlobalFilter.pluginName = 'useGlobalFilter';

function reducer$3(state, action, previousState, instance) {
  if (action.type === actions.resetGlobalFilter) {
    return _extends({}, state, {
      globalFilter: instance.initialState.globalFilter || undefined
    });
  }

  if (action.type === actions.setGlobalFilter) {
    var filterValue = action.filterValue;
    var userFilterTypes = instance.userFilterTypes;
    var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
    var newFilter = functionalUpdate(filterValue, state.globalFilter); //

    if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
      var globalFilter = state.globalFilter,
          stateWithoutGlobalFilter = _objectWithoutPropertiesLoose(state, ["globalFilter"]);

      return stateWithoutGlobalFilter;
    }

    return _extends({}, state, {
      globalFilter: newFilter
    });
  }
}

function useInstance$3(instance) {
  var data = instance.data,
      rows = instance.rows,
      flatRows = instance.flatRows,
      rowsById = instance.rowsById,
      allColumns = instance.allColumns,
      userFilterTypes = instance.filterTypes,
      globalFilter = instance.globalFilter,
      manualGlobalFilter = instance.manualGlobalFilter,
      globalFilterValue = instance.state.globalFilter,
      dispatch = instance.dispatch,
      _instance$autoResetGl = instance.autoResetGlobalFilter,
      autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl;
  var setGlobalFilter = React.useCallback(function (filterValue) {
    dispatch({
      type: actions.setGlobalFilter,
      filterValue: filterValue
    });
  }, [dispatch]); // TODO: Create a filter cache for incremental high speed multi-filtering
  // This gets pretty complicated pretty fast, since you have to maintain a
  // cache for each row group (top-level rows, and each row's recursive subrows)
  // This would make multi-filtering a lot faster though. Too far?

  var _React$useMemo = React.useMemo(function () {
    if (manualGlobalFilter || typeof globalFilterValue === 'undefined') {
      return [rows, flatRows, rowsById];
    }

    var filteredFlatRows = [];
    var filteredRowsById = {};
    var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);

    if (!filterMethod) {
      console.warn("Could not find a valid 'globalFilter' option.");
      return rows;
    } // Filters top level and nested rows


    var filterRows = function filterRows(filteredRows) {
      return filterMethod(filteredRows, allColumns.map(function (d) {
        return d.id;
      }), globalFilterValue).map(function (row) {
        filteredFlatRows.push(row);
        filteredRowsById[row.id] = row;
        return _extends({}, row, {
          subRows: row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows
        });
      });
    };

    return [filterRows(rows), filteredFlatRows, filteredRowsById];
  }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, rows, flatRows, rowsById, allColumns]),
      globalFilteredRows = _React$useMemo[0],
      globalFilteredFlatRows = _React$useMemo[1],
      globalFilteredRowsById = _React$useMemo[2];

  var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
  useMountedLayoutEffect(function () {
    if (getAutoResetGlobalFilter()) {
      dispatch({
        type: actions.resetGlobalFilter
      });
    }
  }, [dispatch, manualGlobalFilter ? null : data]);
  Object.assign(instance, {
    preGlobalFilteredRows: rows,
    preGlobalFilteredFlatRows: flatRows,
    preGlobalFilteredRowsById: rowsById,
    globalFilteredRows: globalFilteredRows,
    globalFilteredFlatRows: globalFilteredFlatRows,
    globalFilteredRowsById: globalFilteredRowsById,
    rows: globalFilteredRows,
    flatRows: globalFilteredFlatRows,
    rowsById: globalFilteredRowsById,
    setGlobalFilter: setGlobalFilter
  });
}

function sum(values, aggregatedValues) {
  // It's faster to just add the aggregations together instead of
  // process leaf nodes individually
  return aggregatedValues.reduce(function (sum, next) {
    return sum + (typeof next === 'number' ? next : 0);
  }, 0);
}
function min(values) {
  var min = 0;
  values.forEach(function (value) {
    if (typeof value === 'number') {
      min = Math.min(min, value);
    }
  });
  return min;
}
function max(values) {
  var max = 0;
  values.forEach(function (value) {
    if (typeof value === 'number') {
      max = Math.max(max, value);
    }
  });
  return max;
}
function minMax(values) {
  var min = 0;
  var max = 0;
  values.forEach(function (value) {
    if (typeof value === 'number') {
      min = Math.min(min, value);
      max = Math.max(max, value);
    }
  });
  return min + ".." + max;
}
function average(values) {
  return sum(null, values) / values.length;
}
function median(values) {
  if (!values.length) {
    return null;
  }

  var min = 0;
  var max = 0;
  values.forEach(function (value) {
    if (typeof value === 'number') {
      min = Math.min(min, value);
      max = Math.max(max, value);
    }
  });
  return (min + max) / 2;
}
function unique(values) {
  return [].concat(new Set(values).values());
}
function uniqueCount(values) {
  return new Set(values).size;
}
function count(values) {
  return values.length;
}

var aggregations = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sum: sum,
  min: min,
  max: max,
  minMax: minMax,
  average: average,
  median: median,
  unique: unique,
  uniqueCount: uniqueCount,
  count: count
});

var emptyArray = [];
var emptyObject = {}; // Actions

actions.resetGroupBy = 'resetGroupBy';
actions.toggleGroupBy = 'toggleGroupBy';
var useGroupBy = function useGroupBy(hooks) {
  hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
  hooks.stateReducers.push(reducer$4);
  hooks.visibleColumnsDeps.push(function (deps, _ref) {
    var instance = _ref.instance;
    return [].concat(deps, [instance.state.groupBy]);
  });
  hooks.visibleColumns.push(visibleColumns);
  hooks.useInstance.push(useInstance$4);
  hooks.prepareRow.push(prepareRow$1);
};
useGroupBy.pluginName = 'useGroupBy';

var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
  var header = _ref2.header;
  return [props, {
    onClick: header.canGroupBy ? function (e) {
      e.persist();
      header.toggleGroupBy();
    } : undefined,
    style: {
      cursor: header.canGroupBy ? 'pointer' : undefined
    },
    title: 'Toggle GroupBy'
  }];
}; // Reducer


function reducer$4(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      groupBy: []
    }, state);
  }

  if (action.type === actions.resetGroupBy) {
    return _extends({}, state, {
      groupBy: instance.initialState.groupBy || []
    });
  }

  if (action.type === actions.toggleGroupBy) {
    var columnId = action.columnId,
        setGroupBy = action.value;
    var resolvedGroupBy = typeof setGroupBy !== 'undefined' ? setGroupBy : !state.groupBy.includes(columnId);

    if (resolvedGroupBy) {
      return _extends({}, state, {
        groupBy: [].concat(state.groupBy, [columnId])
      });
    }

    return _extends({}, state, {
      groupBy: state.groupBy.filter(function (d) {
        return d !== columnId;
      })
    });
  }
}

function visibleColumns(columns, _ref3) {
  var groupBy = _ref3.instance.state.groupBy;
  // Sort grouped columns to the start of the column list
  // before the headers are built
  var groupByColumns = groupBy.map(function (g) {
    return columns.find(function (col) {
      return col.id === g;
    });
  }).filter(Boolean);
  var nonGroupByColumns = columns.filter(function (col) {
    return !groupBy.includes(col.id);
  });
  columns = [].concat(groupByColumns, nonGroupByColumns);
  columns.forEach(function (column) {
    column.isGrouped = groupBy.includes(column.id);
    column.groupedIndex = groupBy.indexOf(column.id);
  });
  return columns;
}

var defaultUserAggregations = {};

function useInstance$4(instance) {
  var data = instance.data,
      rows = instance.rows,
      flatRows = instance.flatRows,
      rowsById = instance.rowsById,
      allColumns = instance.allColumns,
      flatHeaders = instance.flatHeaders,
      _instance$groupByFn = instance.groupByFn,
      groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn,
      manualGroupBy = instance.manualGroupBy,
      _instance$aggregation = instance.aggregations,
      userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation,
      plugins = instance.plugins,
      groupBy = instance.state.groupBy,
      dispatch = instance.dispatch,
      _instance$autoResetGr = instance.autoResetGroupBy,
      autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr,
      disableGroupBy = instance.disableGroupBy,
      defaultCanGroupBy = instance.defaultCanGroupBy,
      getHooks = instance.getHooks;
  ensurePluginOrder(plugins, ['useFilters'], 'useGroupBy');
  var getInstance = useGetLatest(instance);
  allColumns.forEach(function (column) {
    var accessor = column.accessor,
        defaultColumnGroupBy = column.defaultGroupBy,
        columnDisableGroupBy = column.disableGroupBy;
    column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : undefined, disableGroupBy === true ? false : undefined, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);

    if (column.canGroupBy) {
      column.toggleGroupBy = function () {
        return instance.toggleGroupBy(column.id);
      };
    }

    column.Aggregated = column.Aggregated || column.Cell;
  });
  var toggleGroupBy = React.useCallback(function (columnId, value) {
    dispatch({
      type: actions.toggleGroupBy,
      columnId: columnId,
      value: value
    });
  }, [dispatch]);
  flatHeaders.forEach(function (header) {
    header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
      instance: getInstance(),
      header: header
    });
  });

  var _React$useMemo = React.useMemo(function () {
    if (manualGroupBy || !groupBy.length) {
      return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
    } // Ensure that the list of filtered columns exist


    var existingGroupBy = groupBy.filter(function (g) {
      return allColumns.find(function (col) {
        return col.id === g;
      });
    }); // Find the columns that can or are aggregating
    // Uses each column to aggregate rows into a single value

    var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
      var values = {};
      allColumns.forEach(function (column) {
        // Don't aggregate columns that are in the groupBy
        if (existingGroupBy.includes(column.id)) {
          values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
          return;
        } // Get the columnValues to aggregate


        var groupedValues = groupedRows.map(function (row) {
          return row.values[column.id];
        }); // Get the columnValues to aggregate

        var leafValues = leafRows.map(function (row) {
          var columnValue = row.values[column.id];

          if (!depth && column.aggregatedValue) {
            var aggregateValueFn = typeof column.aggregateValue === 'function' ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];

            if (!aggregateValueFn) {
              console.info({
                column: column
              });
              throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
            }

            columnValue = aggregateValueFn(columnValue, row, column);
          }

          return columnValue;
        }); // Aggregate the values

        var aggregateFn = typeof column.aggregate === 'function' ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];

        if (aggregateFn) {
          values[column.id] = aggregateFn(leafValues, groupedValues);
        } else if (column.aggregate) {
          console.info({
            column: column
          });
          throw new Error("React Table: Invalid column.aggregate option for column listed above");
        } else {
          values[column.id] = null;
        }
      });
      return values;
    };

    var groupedFlatRows = [];
    var groupedRowsById = {};
    var onlyGroupedFlatRows = [];
    var onlyGroupedRowsById = {};
    var nonGroupedFlatRows = [];
    var nonGroupedRowsById = {}; // Recursively group the data

    var groupUpRecursively = function groupUpRecursively(rows, depth, parentId) {
      if (depth === void 0) {
        depth = 0;
      }

      // This is the last level, just return the rows
      if (depth === existingGroupBy.length) {
        return rows;
      }

      var columnId = existingGroupBy[depth]; // Group the rows together for this level

      var rowGroupsMap = groupByFn(rows, columnId); // Peform aggregations for each group

      var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function (_ref4, index) {
        var groupByVal = _ref4[0],
            groupedRows = _ref4[1];
        var id = columnId + ":" + groupByVal;
        id = parentId ? parentId + ">" + id : id; // First, Recurse to group sub rows before aggregation

        var subRows = groupUpRecursively(groupedRows, depth + 1, id); // Flatten the leaf rows of the rows in this group

        var leafRows = depth ? flattenBy(groupedRows, 'leafRows') : groupedRows;
        var values = aggregateRowsToValues(leafRows, groupedRows, depth);
        var row = {
          id: id,
          isGrouped: true,
          groupByID: columnId,
          groupByVal: groupByVal,
          values: values,
          subRows: subRows,
          leafRows: leafRows,
          depth: depth,
          index: index
        };
        subRows.forEach(function (subRow) {
          groupedFlatRows.push(subRow);
          groupedRowsById[subRow.id] = subRow;

          if (subRow.isGrouped) {
            onlyGroupedFlatRows.push(subRow);
            onlyGroupedRowsById[subRow.id] = subRow;
          } else {
            nonGroupedFlatRows.push(subRow);
            nonGroupedRowsById[subRow.id] = subRow;
          }
        });
        return row;
      });
      return aggregatedGroupedRows;
    };

    var groupedRows = groupUpRecursively(rows);
    groupedRows.forEach(function (subRow) {
      groupedFlatRows.push(subRow);
      groupedRowsById[subRow.id] = subRow;

      if (subRow.isGrouped) {
        onlyGroupedFlatRows.push(subRow);
        onlyGroupedRowsById[subRow.id] = subRow;
      } else {
        nonGroupedFlatRows.push(subRow);
        nonGroupedRowsById[subRow.id] = subRow;
      }
    }); // Assign the new data

    return [groupedRows, groupedFlatRows, groupedRowsById, onlyGroupedFlatRows, onlyGroupedRowsById, nonGroupedFlatRows, nonGroupedRowsById];
  }, [manualGroupBy, groupBy, rows, flatRows, rowsById, allColumns, userAggregations, groupByFn]),
      groupedRows = _React$useMemo[0],
      groupedFlatRows = _React$useMemo[1],
      groupedRowsById = _React$useMemo[2],
      onlyGroupedFlatRows = _React$useMemo[3],
      onlyGroupedRowsById = _React$useMemo[4],
      nonGroupedFlatRows = _React$useMemo[5],
      nonGroupedRowsById = _React$useMemo[6];

  var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
  useMountedLayoutEffect(function () {
    if (getAutoResetGroupBy()) {
      dispatch({
        type: actions.resetGroupBy
      });
    }
  }, [dispatch, manualGroupBy ? null : data]);
  Object.assign(instance, {
    preGroupedRows: rows,
    preGroupedFlatRow: flatRows,
    preGroupedRowsById: rowsById,
    groupedRows: groupedRows,
    groupedFlatRows: groupedFlatRows,
    groupedRowsById: groupedRowsById,
    onlyGroupedFlatRows: onlyGroupedFlatRows,
    onlyGroupedRowsById: onlyGroupedRowsById,
    nonGroupedFlatRows: nonGroupedFlatRows,
    nonGroupedRowsById: nonGroupedRowsById,
    rows: groupedRows,
    flatRows: groupedFlatRows,
    rowsById: groupedRowsById,
    toggleGroupBy: toggleGroupBy
  });
}

function prepareRow$1(row) {
  row.allCells.forEach(function (cell) {
    // Grouped cells are in the groupBy and the pivot cell for the row
    cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID; // Placeholder cells are any columns in the groupBy that are not grouped

    cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped; // Aggregated cells are not grouped, not repeated, but still have subRows

    cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && row.canExpand;
  });
}

var reSplitAlphaNumeric = /([0-9]+)/gm; // Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity

var alphanumeric = function alphanumeric(rowA, rowB, columnId) {
  var a = getRowValueByColumnID(rowA, columnId);
  var b = getRowValueByColumnID(rowB, columnId); // Force to strings (or "" for unsupported types)

  a = toString(a);
  b = toString(b); // Split on number groups, but keep the delimiter
  // Then remove falsey split values

  a = a.split(reSplitAlphaNumeric).filter(Boolean);
  b = b.split(reSplitAlphaNumeric).filter(Boolean); // While

  while (a.length && b.length) {
    var aa = a.shift();
    var bb = b.shift();
    var an = parseInt(aa, 10);
    var bn = parseInt(bb, 10);
    var combo = [an, bn].sort(); // Both are string

    if (isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }

      if (bb > aa) {
        return -1;
      }

      continue;
    } // One is a string, one is a number


    if (isNaN(combo[1])) {
      return isNaN(an) ? -1 : 1;
    } // Both are numbers


    if (an > bn) {
      return 1;
    }

    if (bn > an) {
      return -1;
    }
  }

  return a.length - b.length;
};
function datetime(rowA, rowB, columnId) {
  var a = getRowValueByColumnID(rowA, columnId);
  var b = getRowValueByColumnID(rowB, columnId);
  a = a.getTime();
  b = b.getTime();
  return compareBasic(a, b);
}
function basic(rowA, rowB, columnId) {
  var a = getRowValueByColumnID(rowA, columnId);
  var b = getRowValueByColumnID(rowB, columnId);
  return compareBasic(a, b);
} // Utils

function compareBasic(a, b) {
  return a === b ? 0 : a > b ? 1 : -1;
}

function getRowValueByColumnID(row, columnId) {
  return row.values[columnId];
}

function toString(a) {
  if (typeof a === 'number') {
    if (isNaN(a) || a === Infinity || a === -Infinity) {
      return '';
    }

    return String(a);
  }

  if (typeof a === 'string') {
    return a;
  }

  return '';
}

var sortTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  alphanumeric: alphanumeric,
  datetime: datetime,
  basic: basic
});

actions.resetSortBy = 'resetSortBy';
actions.toggleSortBy = 'toggleSortBy';
actions.clearSortBy = 'clearSortBy';
defaultColumn.sortType = 'alphanumeric';
defaultColumn.sortDescFirst = false;
var useSortBy = function useSortBy(hooks) {
  hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
  hooks.stateReducers.push(reducer$5);
  hooks.useInstance.push(useInstance$5);
};
useSortBy.pluginName = 'useSortBy';

var defaultGetSortByToggleProps = function defaultGetSortByToggleProps(props, _ref) {
  var instance = _ref.instance,
      column = _ref.column;
  var _instance$isMultiSort = instance.isMultiSortEvent,
      isMultiSortEvent = _instance$isMultiSort === void 0 ? function (e) {
    return e.shiftKey;
  } : _instance$isMultiSort;
  return [props, {
    onClick: column.canSort ? function (e) {
      e.persist();
      column.toggleSortBy(undefined, !instance.disableMultiSort && isMultiSortEvent(e));
    } : undefined,
    style: {
      cursor: column.canSort ? 'pointer' : undefined
    },
    title: column.canSort ? 'Toggle SortBy' : undefined
  }];
}; // Reducer


function reducer$5(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      sortBy: []
    }, state);
  }

  if (action.type === actions.resetSortBy) {
    return _extends({}, state, {
      sortBy: instance.initialState.sortBy || []
    });
  }

  if (action.type === actions.clearSortBy) {
    var sortBy = state.sortBy;
    var newSortBy = sortBy.filter(function (d) {
      return d.id !== action.columnId;
    });
    return _extends({}, state, {
      sortBy: newSortBy
    });
  }

  if (action.type === actions.toggleSortBy) {
    var columnId = action.columnId,
        desc = action.desc,
        multi = action.multi;
    var allColumns = instance.allColumns,
        disableMultiSort = instance.disableMultiSort,
        disableSortRemove = instance.disableSortRemove,
        disableMultiRemove = instance.disableMultiRemove,
        _instance$maxMultiSor = instance.maxMultiSortColCount,
        maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
    var _sortBy = state.sortBy; // Find the column for this columnId

    var column = allColumns.find(function (d) {
      return d.id === columnId;
    });
    var sortDescFirst = column.sortDescFirst; // Find any existing sortBy for this column

    var existingSortBy = _sortBy.find(function (d) {
      return d.id === columnId;
    });

    var existingIndex = _sortBy.findIndex(function (d) {
      return d.id === columnId;
    });

    var hasDescDefined = typeof desc !== 'undefined' && desc !== null;
    var _newSortBy = []; // What should we do with this sort action?

    var sortAction;

    if (!disableMultiSort && multi) {
      if (existingSortBy) {
        sortAction = 'toggle';
      } else {
        sortAction = 'add';
      }
    } else {
      // Normal mode
      if (existingIndex !== _sortBy.length - 1) {
        sortAction = 'replace';
      } else if (existingSortBy) {
        sortAction = 'toggle';
      } else {
        sortAction = 'replace';
      }
    } // Handle toggle states that will remove the sortBy


    if (sortAction === 'toggle' && // Must be toggling
    !disableSortRemove && // If disableSortRemove, disable in general
    !hasDescDefined && ( // Must not be setting desc
    multi ? !disableMultiRemove : true) && ( // If multi, don't allow if disableMultiRemove
    existingSortBy && // Finally, detect if it should indeed be removed
    existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) {
      sortAction = 'remove';
    }

    if (sortAction === 'replace') {
      _newSortBy = [{
        id: columnId,
        desc: hasDescDefined ? desc : sortDescFirst
      }];
    } else if (sortAction === 'add') {
      _newSortBy = [].concat(_sortBy, [{
        id: columnId,
        desc: hasDescDefined ? desc : sortDescFirst
      }]); // Take latest n columns

      _newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
    } else if (sortAction === 'toggle') {
      // This flips (or sets) the
      _newSortBy = _sortBy.map(function (d) {
        if (d.id === columnId) {
          return _extends({}, d, {
            desc: hasDescDefined ? desc : !existingSortBy.desc
          });
        }

        return d;
      });
    } else if (sortAction === 'remove') {
      _newSortBy = _sortBy.filter(function (d) {
        return d.id !== columnId;
      });
    }

    return _extends({}, state, {
      sortBy: _newSortBy
    });
  }
}

function useInstance$5(instance) {
  var data = instance.data,
      rows = instance.rows,
      flatRows = instance.flatRows,
      allColumns = instance.allColumns,
      _instance$orderByFn = instance.orderByFn,
      orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn,
      userSortTypes = instance.sortTypes,
      manualSortBy = instance.manualSortBy,
      defaultCanSort = instance.defaultCanSort,
      disableSortBy = instance.disableSortBy,
      flatHeaders = instance.flatHeaders,
      sortBy = instance.state.sortBy,
      dispatch = instance.dispatch,
      plugins = instance.plugins,
      getHooks = instance.getHooks,
      _instance$autoResetSo = instance.autoResetSortBy,
      autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
  ensurePluginOrder(plugins, ['useFilters', 'useGlobalFilter', 'useGroupBy', 'usePivotColumns'], 'useSortBy'); // Updates sorting based on a columnId, desc flag and multi flag

  var toggleSortBy = React.useCallback(function (columnId, desc, multi) {
    dispatch({
      type: actions.toggleSortBy,
      columnId: columnId,
      desc: desc,
      multi: multi
    });
  }, [dispatch]); // use reference to avoid memory leak in #1608

  var getInstance = useGetLatest(instance); // Add the getSortByToggleProps method to columns and headers

  flatHeaders.forEach(function (column) {
    var accessor = column.accessor,
        defaultColumnCanSort = column.canSort,
        columnDisableSortBy = column.disableSortBy,
        id = column.id;
    var canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : undefined, disableSortBy === true ? false : undefined, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
    column.canSort = canSort;

    if (column.canSort) {
      column.toggleSortBy = function (desc, multi) {
        return toggleSortBy(column.id, desc, multi);
      };

      column.clearSortBy = function () {
        dispatch({
          type: actions.clearSortBy,
          columnId: column.id
        });
      };
    }

    column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
      instance: getInstance(),
      column: column
    });
    var columnSort = sortBy.find(function (d) {
      return d.id === id;
    });
    column.isSorted = !!columnSort;
    column.sortedIndex = sortBy.findIndex(function (d) {
      return d.id === id;
    });
    column.isSortedDesc = column.isSorted ? columnSort.desc : undefined;
  });

  var _React$useMemo = React.useMemo(function () {
    if (manualSortBy || !sortBy.length) {
      return [rows, flatRows];
    }

    var sortedFlatRows = []; // Filter out sortBys that correspond to non existing columns

    var availableSortBy = sortBy.filter(function (sort) {
      return allColumns.find(function (col) {
        return col.id === sort.id;
      });
    });

    var sortData = function sortData(rows) {
      // Use the orderByFn to compose multiple sortBy's together.
      // This will also perform a stable sorting using the row index
      // if needed.
      var sortedData = orderByFn(rows, availableSortBy.map(function (sort) {
        // Support custom sorting methods for each column
        var column = allColumns.find(function (d) {
          return d.id === sort.id;
        });

        if (!column) {
          throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
        }

        var sortType = column.sortType; // Look up sortBy functions in this order:
        // column function
        // column string lookup on user sortType
        // column string lookup on built-in sortType
        // default function
        // default string lookup on user sortType
        // default string lookup on built-in sortType

        var sortMethod = isFunction(sortType) || (userSortTypes || {})[sortType] || sortTypes[sortType];

        if (!sortMethod) {
          throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
        } // Return the correct sortFn.
        // This function should always return in ascending order


        return function (a, b) {
          return sortMethod(a, b, sort.id, sort.desc);
        };
      }), // Map the directions
      availableSortBy.map(function (sort) {
        // Detect and use the sortInverted option
        var column = allColumns.find(function (d) {
          return d.id === sort.id;
        });

        if (column && column.sortInverted) {
          return sort.desc;
        }

        return !sort.desc;
      })); // If there are sub-rows, sort them

      sortedData.forEach(function (row) {
        sortedFlatRows.push(row);

        if (!row.subRows || row.subRows.length <= 1) {
          return;
        }

        row.subRows = sortData(row.subRows);
      });
      return sortedData;
    };

    return [sortData(rows), sortedFlatRows];
  }, [manualSortBy, sortBy, rows, flatRows, allColumns, orderByFn, userSortTypes]),
      sortedRows = _React$useMemo[0],
      sortedFlatRows = _React$useMemo[1];

  var getAutoResetSortBy = useGetLatest(autoResetSortBy);
  useMountedLayoutEffect(function () {
    if (getAutoResetSortBy()) {
      dispatch({
        type: actions.resetSortBy
      });
    }
  }, [manualSortBy ? null : data]);
  Object.assign(instance, {
    preSortedRows: rows,
    preSortedFlatRows: flatRows,
    sortedRows: sortedRows,
    sortedFlatRows: sortedFlatRows,
    rows: sortedRows,
    flatRows: sortedFlatRows,
    toggleSortBy: toggleSortBy
  });
}

var pluginName = 'usePagination'; // Actions

actions.resetPage = 'resetPage';
actions.gotoPage = 'gotoPage';
actions.setPageSize = 'setPageSize';
var usePagination = function usePagination(hooks) {
  hooks.stateReducers.push(reducer$6);
  hooks.useInstance.push(useInstance$6);
};
usePagination.pluginName = pluginName;

function reducer$6(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      pageSize: 10,
      pageIndex: 0
    }, state);
  }

  if (action.type === actions.resetPage) {
    return _extends({}, state, {
      pageIndex: instance.initialState.pageIndex || 0
    });
  }

  if (action.type === actions.gotoPage) {
    var pageCount = instance.pageCount;
    var newPageIndex = functionalUpdate(action.pageIndex, state.pageIndex);

    if (newPageIndex < 0 || newPageIndex > pageCount - 1) {
      return state;
    }

    return _extends({}, state, {
      pageIndex: newPageIndex
    });
  }

  if (action.type === actions.setPageSize) {
    var pageSize = action.pageSize;
    var topRowIndex = state.pageSize * state.pageIndex;
    var pageIndex = Math.floor(topRowIndex / pageSize);
    return _extends({}, state, {
      pageIndex: pageIndex,
      pageSize: pageSize
    });
  }
}

function useInstance$6(instance) {
  var rows = instance.rows,
      _instance$autoResetPa = instance.autoResetPage,
      autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa,
      _instance$manualExpan = instance.manualExpandedKey,
      manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
      plugins = instance.plugins,
      userPageCount = instance.pageCount,
      _instance$paginateExp = instance.paginateExpandedRows,
      paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
      _instance$expandSubRo = instance.expandSubRows,
      expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
      _instance$state = instance.state,
      pageSize = _instance$state.pageSize,
      pageIndex = _instance$state.pageIndex,
      expanded = _instance$state.expanded,
      globalFilter = _instance$state.globalFilter,
      filters = _instance$state.filters,
      groupBy = _instance$state.groupBy,
      sortBy = _instance$state.sortBy,
      dispatch = instance.dispatch,
      data = instance.data,
      manualPagination = instance.manualPagination,
      manualGlobalFilter = instance.manualGlobalFilter,
      manualFilters = instance.manualFilters,
      manualGroupBy = instance.manualGroupBy,
      manualSortBy = instance.manualSortBy;
  ensurePluginOrder(plugins, ['useGlobalFilter', 'useFilters', 'useGroupBy', 'useSortBy', 'useExpanded'], 'usePagination');
  var getAutoResetPage = useGetLatest(autoResetPage);
  useMountedLayoutEffect(function () {
    if (getAutoResetPage()) {
      dispatch({
        type: actions.resetPage
      });
    }
  }, [dispatch, manualPagination ? null : data, manualGlobalFilter ? null : globalFilter, manualFilters ? null : filters, manualGroupBy ? null : groupBy, manualSortBy ? null : sortBy]);
  var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
  var pageOptions = React.useMemo(function () {
    return pageCount > 0 ? [].concat(new Array(pageCount)).map(function (d, i) {
      return i;
    }) : [];
  }, [pageCount]);
  var page = React.useMemo(function () {
    var page;

    if (manualPagination) {
      page = rows;
    } else {
      var pageStart = pageSize * pageIndex;
      var pageEnd = pageStart + pageSize;
      page = rows.slice(pageStart, pageEnd);
    }

    if (paginateExpandedRows) {
      return page;
    }

    return expandRows(page, {
      manualExpandedKey: manualExpandedKey,
      expanded: expanded,
      expandSubRows: expandSubRows
    });
  }, [expandSubRows, expanded, manualExpandedKey, manualPagination, pageIndex, pageSize, paginateExpandedRows, rows]);
  var canPreviousPage = pageIndex > 0;
  var canNextPage = pageCount === -1 || pageIndex < pageCount - 1;
  var gotoPage = React.useCallback(function (pageIndex) {
    dispatch({
      type: actions.gotoPage,
      pageIndex: pageIndex
    });
  }, [dispatch]);
  var previousPage = React.useCallback(function () {
    return gotoPage(function (old) {
      return old - 1;
    });
  }, [gotoPage]);
  var nextPage = React.useCallback(function () {
    return gotoPage(function (old) {
      return old + 1;
    });
  }, [gotoPage]);
  var setPageSize = React.useCallback(function (pageSize) {
    dispatch({
      type: actions.setPageSize,
      pageSize: pageSize
    });
  }, [dispatch]);
  Object.assign(instance, {
    pageOptions: pageOptions,
    pageCount: pageCount,
    page: page,
    canPreviousPage: canPreviousPage,
    canNextPage: canNextPage,
    gotoPage: gotoPage,
    previousPage: previousPage,
    nextPage: nextPage,
    setPageSize: setPageSize
  });
}

actions.resetPivot = 'resetPivot';
actions.togglePivot = 'togglePivot';
var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
  hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
  hooks.stateReducers.push(reducer$7);
  hooks.useInstanceAfterData.push(useInstanceAfterData);
  hooks.allColumns.push(allColumns);
  hooks.accessValue.push(accessValue);
  hooks.materializedColumns.push(materializedColumns);
  hooks.materializedColumnsDeps.push(materializedColumnsDeps);
  hooks.visibleColumns.push(visibleColumns$1);
  hooks.visibleColumnsDeps.push(visibleColumnsDeps);
  hooks.useInstance.push(useInstance$7);
  hooks.prepareRow.push(prepareRow$2);
};
_UNSTABLE_usePivotColumns.pluginName = 'usePivotColumns';
var defaultPivotColumns = [];

var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
  var header = _ref.header;
  return [props, {
    onClick: header.canPivot ? function (e) {
      e.persist();
      header.togglePivot();
    } : undefined,
    style: {
      cursor: header.canPivot ? 'pointer' : undefined
    },
    title: 'Toggle Pivot'
  }];
}; // Reducer


function reducer$7(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      pivotColumns: defaultPivotColumns
    }, state);
  }

  if (action.type === actions.resetPivot) {
    return _extends({}, state, {
      pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
    });
  }

  if (action.type === actions.togglePivot) {
    var columnId = action.columnId,
        setPivot = action.value;
    var resolvedPivot = typeof setPivot !== 'undefined' ? setPivot : !state.pivotColumns.includes(columnId);

    if (resolvedPivot) {
      return _extends({}, state, {
        pivotColumns: [].concat(state.pivotColumns, [columnId])
      });
    }

    return _extends({}, state, {
      pivotColumns: state.pivotColumns.filter(function (d) {
        return d !== columnId;
      })
    });
  }
}

function useInstanceAfterData(instance) {
  instance.allColumns.forEach(function (column) {
    column.isPivotSource = instance.state.pivotColumns.includes(column.id);
  });
}

function allColumns(columns, _ref2) {
  var instance = _ref2.instance;
  columns.forEach(function (column) {
    column.isPivotSource = instance.state.pivotColumns.includes(column.id);
    column.uniqueValues = new Set();
  });
  return columns;
}

function accessValue(value, _ref3) {
  var column = _ref3.column;

  if (column.uniqueValues && typeof value !== 'undefined') {
    column.uniqueValues.add(value);
  }

  return value;
}

function materializedColumns(materialized, _ref4) {
  var instance = _ref4.instance;
  var allColumns = instance.allColumns,
      state = instance.state;

  if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
    return materialized;
  }

  var pivotColumns = state.pivotColumns.map(function (id) {
    return allColumns.find(function (d) {
      return d.id === id;
    });
  }).filter(Boolean);
  var sourceColumns = allColumns.filter(function (d) {
    return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
  });

  var buildPivotColumns = function buildPivotColumns(depth, parent, pivotFilters) {
    if (depth === void 0) {
      depth = 0;
    }

    if (pivotFilters === void 0) {
      pivotFilters = [];
    }

    var pivotColumn = pivotColumns[depth];

    if (!pivotColumn) {
      return sourceColumns.map(function (sourceColumn) {
        // TODO: We could offer support here for renesting pivoted
        // columns inside copies of their header groups. For now,
        // that seems like it would be (1) overkill on nesting, considering
        // you already get nesting for every pivot level and (2)
        // really hard. :)
        return _extends({}, sourceColumn, {
          canPivot: false,
          isPivoted: true,
          parent: parent,
          depth: depth,
          id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
          accessor: function accessor(originalRow, i, row) {
            if (pivotFilters.every(function (filter) {
              return filter(row);
            })) {
              return row.values[sourceColumn.id];
            }
          }
        });
      });
    }

    var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
    return uniqueValues.map(function (uniqueValue) {
      var columnGroup = _extends({}, pivotColumn, {
        Header: pivotColumn.PivotHeader || typeof pivotColumn.header === 'string' ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
        isPivotGroup: true,
        parent: parent,
        depth: depth,
        id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
        pivotValue: uniqueValue
      });

      columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(pivotFilters, [function (row) {
        return row.values[pivotColumn.id] === uniqueValue;
      }]));
      return columnGroup;
    });
  };

  var newMaterialized = flattenColumns(buildPivotColumns());
  return [].concat(materialized, newMaterialized);
}

function materializedColumnsDeps(deps, _ref5) {
  var _ref5$instance$state = _ref5.instance.state,
      pivotColumns = _ref5$instance$state.pivotColumns,
      groupBy = _ref5$instance$state.groupBy;
  return [].concat(deps, [pivotColumns, groupBy]);
}

function visibleColumns$1(visibleColumns, _ref6) {
  var state = _ref6.instance.state;
  visibleColumns = visibleColumns.filter(function (d) {
    return !d.isPivotSource;
  });

  if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
    visibleColumns = visibleColumns.filter(function (column) {
      return column.isGrouped || column.isPivoted;
    });
  }

  return visibleColumns;
}

function visibleColumnsDeps(deps, _ref7) {
  var instance = _ref7.instance;
  return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
}

function useInstance$7(instance) {
  var columns = instance.columns,
      allColumns = instance.allColumns,
      flatHeaders = instance.flatHeaders,
      getHooks = instance.getHooks,
      plugins = instance.plugins,
      dispatch = instance.dispatch,
      _instance$autoResetPi = instance.autoResetPivot,
      autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi,
      manaulPivot = instance.manaulPivot,
      disablePivot = instance.disablePivot,
      defaultCanPivot = instance.defaultCanPivot;
  ensurePluginOrder(plugins, ['useGroupBy'], 'usePivotColumns');
  var getInstance = useGetLatest(instance);
  allColumns.forEach(function (column) {
    var accessor = column.accessor,
        defaultColumnPivot = column.defaultPivot,
        columnDisablePivot = column.disablePivot;
    column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : undefined, disablePivot === true ? false : undefined, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);

    if (column.canPivot) {
      column.togglePivot = function () {
        return instance.togglePivot(column.id);
      };
    }

    column.Aggregated = column.Aggregated || column.Cell;
  });

  var togglePivot = function togglePivot(columnId, value) {
    dispatch({
      type: actions.togglePivot,
      columnId: columnId,
      value: value
    });
  };

  flatHeaders.forEach(function (header) {
    header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
      instance: getInstance(),
      header: header
    });
  });
  var getAutoResetPivot = useGetLatest(autoResetPivot);
  useMountedLayoutEffect(function () {
    if (getAutoResetPivot()) {
      dispatch({
        type: actions.resetPivot
      });
    }
  }, [dispatch, manaulPivot ? null : columns]);
  Object.assign(instance, {
    togglePivot: togglePivot
  });
}

function prepareRow$2(row) {
  row.allCells.forEach(function (cell) {
    // Grouped cells are in the pivotColumns and the pivot cell for the row
    cell.isPivoted = cell.column.isPivoted;
  });
}

var pluginName$1 = 'useRowSelect'; // Actions

actions.resetSelectedRows = 'resetSelectedRows';
actions.toggleAllRowsSelected = 'toggleAllRowsSelected';
actions.toggleRowSelected = 'toggleRowSelected';
var useRowSelect = function useRowSelect(hooks) {
  hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
  hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
  hooks.stateReducers.push(reducer$8);
  hooks.useInstance.push(useInstance$8);
  hooks.prepareRow.push(prepareRow$3);
};
useRowSelect.pluginName = pluginName$1;

var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps(props, _ref) {
  var instance = _ref.instance,
      row = _ref.row;
  var _instance$manualRowSe = instance.manualRowSelectedKey,
      manualRowSelectedKey = _instance$manualRowSe === void 0 ? 'isSelected' : _instance$manualRowSe;
  var checked = false;

  if (row.original && row.original[manualRowSelectedKey]) {
    checked = true;
  } else {
    checked = row.isSelected;
  }

  return [props, {
    onChange: function onChange(e) {
      row.toggleRowSelected(e.target.checked);
    },
    style: {
      cursor: 'pointer'
    },
    checked: checked,
    title: 'Toggle Row Selected',
    indeterminate: row.isSomeSelected
  }];
};

var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps(props, _ref2) {
  var instance = _ref2.instance;
  return [props, {
    onChange: function onChange(e) {
      instance.toggleAllRowsSelected(e.target.checked);
    },
    style: {
      cursor: 'pointer'
    },
    checked: instance.isAllRowsSelected,
    title: 'Toggle All Rows Selected',
    indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
  }];
};

function reducer$8(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      selectedRowIds: {}
    }, state);
  }

  if (action.type === actions.resetSelectedRows) {
    return _extends({}, state, {
      selectedRowIds: instance.initialState.selectedRowIds || {}
    });
  }

  if (action.type === actions.toggleAllRowsSelected) {
    var setSelected = action.value;
    var isAllRowsSelected = instance.isAllRowsSelected,
        rowsById = instance.rowsById,
        _instance$nonGroupedR = instance.nonGroupedRowsById,
        nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
    var selectAll = typeof setSelected !== 'undefined' ? setSelected : !isAllRowsSelected;

    if (selectAll) {
      var selectedRowIds = {};
      Object.keys(nonGroupedRowsById).forEach(function (rowId) {
        selectedRowIds[rowId] = true;
      });
      return _extends({}, state, {
        selectedRowIds: selectedRowIds
      });
    }

    return _extends({}, state, {
      selectedRowIds: {}
    });
  }

  if (action.type === actions.toggleRowSelected) {
    var id = action.id,
        _setSelected = action.value;
    var _rowsById = instance.rowsById,
        _instance$selectSubRo = instance.selectSubRows,
        selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo; // Join the ids of deep rows
    // to make a key, then manage all of the keys
    // in a flat object

    var row = _rowsById[id];
    var isSelected = row.isSelected;
    var shouldExist = typeof _setSelected !== 'undefined' ? _setSelected : !isSelected;

    if (isSelected === shouldExist) {
      return state;
    }

    var newSelectedRowIds = _extends({}, state.selectedRowIds);

    var handleRowById = function handleRowById(id) {
      var row = _rowsById[id];

      if (!row.isGrouped) {
        if (!isSelected && shouldExist) {
          newSelectedRowIds[id] = true;
        } else if (isSelected && !shouldExist) {
          delete newSelectedRowIds[id];
        }
      }

      if (selectSubRows && row.subRows) {
        return row.subRows.forEach(function (row) {
          return handleRowById(row.id);
        });
      }
    };

    handleRowById(id);
    return _extends({}, state, {
      selectedRowIds: newSelectedRowIds
    });
  }
}

function useInstance$8(instance) {
  var data = instance.data,
      rows = instance.rows,
      getHooks = instance.getHooks,
      plugins = instance.plugins,
      rowsById = instance.rowsById,
      _instance$nonGroupedR2 = instance.nonGroupedRowsById,
      nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2,
      _instance$autoResetSe = instance.autoResetSelectedRows,
      autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe,
      selectedRowIds = instance.state.selectedRowIds,
      _instance$selectSubRo2 = instance.selectSubRows,
      selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2,
      dispatch = instance.dispatch;
  ensurePluginOrder(plugins, ['useFilters', 'useGroupBy', 'useSortBy'], 'useRowSelect');
  var selectedFlatRows = React.useMemo(function () {
    var selectedFlatRows = [];
    rows.forEach(function (row) {
      var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds) : !!selectedRowIds[row.id];
      row.isSelected = !!isSelected;
      row.isSomeSelected = isSelected === null;

      if (isSelected) {
        selectedFlatRows.push(row);
      }
    });
    return selectedFlatRows;
  }, [rows, selectSubRows, selectedRowIds]);
  var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);

  if (isAllRowsSelected) {
    if (Object.keys(nonGroupedRowsById).some(function (id) {
      return !selectedRowIds[id];
    })) {
      isAllRowsSelected = false;
    }
  }

  var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
  useMountedLayoutEffect(function () {
    if (getAutoResetSelectedRows()) {
      dispatch({
        type: actions.resetSelectedRows
      });
    }
  }, [dispatch, data]);
  var toggleAllRowsSelected = React.useCallback(function (value) {
    return dispatch({
      type: actions.toggleAllRowsSelected,
      value: value
    });
  }, [dispatch]);
  var toggleRowSelected = React.useCallback(function (id, value) {
    return dispatch({
      type: actions.toggleRowSelected,
      id: id,
      value: value
    });
  }, [dispatch]);
  var getInstance = useGetLatest(instance);
  var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, {
    instance: getInstance()
  });
  Object.assign(instance, {
    selectedFlatRows: selectedFlatRows,
    isAllRowsSelected: isAllRowsSelected,
    toggleRowSelected: toggleRowSelected,
    toggleAllRowsSelected: toggleAllRowsSelected,
    getToggleAllRowsSelectedProps: getToggleAllRowsSelectedProps
  });
}

function prepareRow$3(row, _ref3) {
  var instance = _ref3.instance;

  row.toggleRowSelected = function (set) {
    return instance.toggleRowSelected(row.id, set);
  };

  row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
    instance: instance,
    row: row
  });
}

function getRowIsSelected(row, selectedRowIds) {
  if (selectedRowIds[row.id]) {
    return true;
  }

  if (row.subRows && row.subRows.length) {
    var allChildrenSelected = true;
    var someSelected = false;
    row.subRows.forEach(function (subRow) {
      // Bail out early if we know both of these
      if (someSelected && !allChildrenSelected) {
        return;
      }

      if (getRowIsSelected(subRow, selectedRowIds)) {
        someSelected = true;
      } else {
        allChildrenSelected = false;
      }
    });
    return allChildrenSelected ? true : someSelected ? null : false;
  }

  return false;
}

var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(originalRow) {
  return {};
};

var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(originalRow) {
  return {};
}; // Actions


actions.setRowState = 'setRowState';
actions.setCellState = 'setCellState';
actions.resetRowState = 'resetRowState';
var useRowState = function useRowState(hooks) {
  hooks.stateReducers.push(reducer$9);
  hooks.useInstance.push(useInstance$9);
  hooks.prepareRow.push(prepareRow$4);
};
useRowState.pluginName = 'useRowState';

function reducer$9(state, action, previousState, instance) {
  var _instance$initialRowS = instance.initialRowStateAccessor,
      initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS,
      _instance$initialCell = instance.initialCellStateAccessor,
      initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell,
      rowsById = instance.rowsById;

  if (action.type === actions.init) {
    return _extends({
      rowState: {}
    }, state);
  }

  if (action.type === actions.resetRowState) {
    return _extends({}, state, {
      rowState: instance.initialState.rowState || {}
    });
  }

  if (action.type === actions.setRowState) {
    var _extends2;

    var rowId = action.rowId,
        value = action.value;
    var oldRowState = typeof state.rowState[rowId] !== 'undefined' ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId].original);
    return _extends({}, state, {
      rowState: _extends({}, state.rowState, (_extends2 = {}, _extends2[rowId] = functionalUpdate(value, oldRowState), _extends2))
    });
  }

  if (action.type === actions.setCellState) {
    var _oldRowState$cellStat, _extends3, _extends4;

    var _rowId = action.rowId,
        columnId = action.columnId,
        _value = action.value;

    var _oldRowState = typeof state.rowState[_rowId] !== 'undefined' ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId].original);

    var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== 'undefined' ? _oldRowState.cellState[columnId] : initialCellStateAccessor(rowsById[_rowId].original);
    return _extends({}, state, {
      rowState: _extends({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends({}, _oldRowState, {
        cellState: _extends({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate(_value, oldCellState), _extends3))
      }), _extends4))
    });
  }
}

function useInstance$9(instance) {
  var _instance$autoResetRo = instance.autoResetRowState,
      autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo,
      data = instance.data,
      dispatch = instance.dispatch;
  var setRowState = React.useCallback(function (rowId, value) {
    return dispatch({
      type: actions.setRowState,
      rowId: rowId,
      value: value
    });
  }, [dispatch]);
  var setCellState = React.useCallback(function (rowId, columnId, value) {
    return dispatch({
      type: actions.setCellState,
      rowId: rowId,
      columnId: columnId,
      value: value
    });
  }, [dispatch]);
  var getAutoResetRowState = useGetLatest(autoResetRowState);
  useMountedLayoutEffect(function () {
    if (getAutoResetRowState()) {
      dispatch({
        type: actions.resetRowState
      });
    }
  }, [data]);
  Object.assign(instance, {
    setRowState: setRowState,
    setCellState: setCellState
  });
}

function prepareRow$4(row, _ref) {
  var instance = _ref.instance;
  var _instance$initialRowS2 = instance.initialRowStateAccessor,
      initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2,
      _instance$initialCell2 = instance.initialCellStateAccessor,
      initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2,
      rowState = instance.state.rowState;

  if (row.original) {
    row.state = typeof rowState[row.id] !== 'undefined' ? rowState[row.id] : initialRowStateAccessor(row.original);

    row.setState = function (updater) {
      return instance.setRowState(row.id, updater);
    };

    row.cells.forEach(function (cell) {
      if (!row.state.cellState) {
        row.state.cellState = {};
      }

      cell.state = typeof row.state.cellState[cell.column.id] !== 'undefined' ? row.state.cellState[cell.column.id] : initialCellStateAccessor(row.original);

      cell.setState = function (updater) {
        return instance.setCellState(row.id, cell.column.id, updater);
      };
    });
  }
}

actions.resetColumnOrder = 'resetColumnOrder';
actions.setColumnOrder = 'setColumnOrder';
var useColumnOrder = function useColumnOrder(hooks) {
  hooks.stateReducers.push(reducer$a);
  hooks.visibleColumnsDeps.push(function (deps, _ref) {
    var instance = _ref.instance;
    return [].concat(deps, [instance.state.columnOrder]);
  });
  hooks.visibleColumns.push(visibleColumns$2);
  hooks.useInstance.push(useInstance$a);
};
useColumnOrder.pluginName = 'useColumnOrder';

function reducer$a(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _extends({
      columnOrder: []
    }, state);
  }

  if (action.type === actions.resetColumnOrder) {
    return _extends({}, state, {
      columnOrder: instance.initialState.columnOrder || []
    });
  }

  if (action.type === actions.setColumnOrder) {
    return _extends({}, state, {
      columnOrder: functionalUpdate(action.columnOrder, state.columnOrder)
    });
  }
}

function visibleColumns$2(columns, _ref2) {
  var columnOrder = _ref2.instance.state.columnOrder;

  // If there is no order, return the normal columns
  if (!columnOrder || !columnOrder.length) {
    return columns;
  }

  var columnOrderCopy = [].concat(columnOrder); // If there is an order, make a copy of the columns

  var columnsCopy = [].concat(columns); // And make a new ordered array of the columns

  var columnsInOrder = []; // Loop over the columns and place them in order into the new array

  var _loop = function _loop() {
    var targetColumnId = columnOrderCopy.shift();
    var foundIndex = columnsCopy.findIndex(function (d) {
      return d.id === targetColumnId;
    });

    if (foundIndex > -1) {
      columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
    }
  };

  while (columnsCopy.length && columnOrderCopy.length) {
    _loop();
  } // If there are any columns left, add them to the end


  return [].concat(columnsInOrder, columnsCopy);
}

function useInstance$a(instance) {
  var dispatch = instance.dispatch;
  instance.setColumnOrder = React.useCallback(function (columnOrder) {
    return dispatch({
      type: actions.setColumnOrder,
      columnOrder: columnOrder
    });
  }, [dispatch]);
}

defaultColumn.canResize = true; // Actions

actions.columnStartResizing = 'columnStartResizing';
actions.columnResizing = 'columnResizing';
actions.columnDoneResizing = 'columnDoneResizing';
var useResizeColumns = function useResizeColumns(hooks) {
  hooks.getResizerProps = [defaultGetResizerProps];
  hooks.getHeaderProps.push({
    style: {
      position: 'relative'
    }
  });
  hooks.stateReducers.push(reducer$b);
  hooks.useInstance.push(useInstance$b);
  hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
};

var defaultGetResizerProps = function defaultGetResizerProps(props, _ref) {
  var instance = _ref.instance,
      header = _ref.header;
  var dispatch = instance.dispatch;

  var onResizeStart = function onResizeStart(e, header) {
    var isTouchEvent = false;

    if (e.type === 'touchstart') {
      // lets not respond to multiple touches (e.g. 2 or 3 fingers)
      if (e.touches && e.touches.length > 1) {
        return;
      }

      isTouchEvent = true;
    }

    var headersToResize = getLeafHeaders(header);
    var headerIdWidths = headersToResize.map(function (d) {
      return [d.id, d.totalWidth];
    });
    var clientX = isTouchEvent ? Math.round(e.touches[0].clientX) : e.clientX;

    var dispatchMove = function dispatchMove(clientXPos) {
      dispatch({
        type: actions.columnResizing,
        clientX: clientXPos
      });
    };

    var dispatchEnd = function dispatchEnd() {
      return dispatch({
        type: actions.columnDoneResizing
      });
    };

    var handlersAndEvents = {
      mouse: {
        moveEvent: 'mousemove',
        moveHandler: function moveHandler(e) {
          return dispatchMove(e.clientX);
        },
        upEvent: 'mouseup',
        upHandler: function upHandler(e) {
          document.removeEventListener('mousemove', handlersAndEvents.mouse.moveHandler);
          document.removeEventListener('mouseup', handlersAndEvents.mouse.upHandler);
          dispatchEnd();
        }
      },
      touch: {
        moveEvent: 'touchmove',
        moveHandler: function moveHandler(e) {
          if (e.cancelable) {
            e.preventDefault();
            e.stopPropagation();
          }

          dispatchMove(e.touches[0].clientX);
          return false;
        },
        upEvent: 'touchend',
        upHandler: function upHandler(e) {
          document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
          document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
          dispatchEnd();
        }
      }
    };
    var events = isTouchEvent ? handlersAndEvents.touch : handlersAndEvents.mouse;
    document.addEventListener(events.moveEvent, events.moveHandler, {
      passive: false
    });
    document.addEventListener(events.upEvent, events.upHandler, {
      passive: false
    });
    dispatch({
      type: actions.columnStartResizing,
      columnId: header.id,
      columnWidth: header.totalWidth,
      headerIdWidths: headerIdWidths,
      clientX: clientX
    });
  };

  return [props, {
    onMouseDown: function onMouseDown(e) {
      return e.persist() || onResizeStart(e, header);
    },
    onTouchStart: function onTouchStart(e) {
      return e.persist() || onResizeStart(e, header);
    },
    style: {
      cursor: 'ew-resize'
    },
    draggable: false,
    role: 'separator'
  }];
};

useResizeColumns.pluginName = 'useResizeColumns';

function reducer$b(state, action) {
  if (action.type === actions.init) {
    return _extends({
      columnResizing: {
        columnWidths: {}
      }
    }, state);
  }

  if (action.type === actions.columnStartResizing) {
    var clientX = action.clientX,
        columnId = action.columnId,
        columnWidth = action.columnWidth,
        headerIdWidths = action.headerIdWidths;
    return _extends({}, state, {
      columnResizing: _extends({}, state.columnResizing, {
        startX: clientX,
        headerIdWidths: headerIdWidths,
        columnWidth: columnWidth,
        isResizingColumn: columnId
      })
    });
  }

  if (action.type === actions.columnResizing) {
    var _clientX = action.clientX;
    var _state$columnResizing = state.columnResizing,
        startX = _state$columnResizing.startX,
        _columnWidth = _state$columnResizing.columnWidth,
        _headerIdWidths = _state$columnResizing.headerIdWidths;
    var deltaX = _clientX - startX;
    var percentageDeltaX = deltaX / _columnWidth;
    var newColumnWidths = {};

    _headerIdWidths.forEach(function (_ref2) {
      var headerId = _ref2[0],
          headerWidth = _ref2[1];
      newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
    });

    return _extends({}, state, {
      columnResizing: _extends({}, state.columnResizing, {
        columnWidths: _extends({}, state.columnResizing.columnWidths, {}, newColumnWidths)
      })
    });
  }

  if (action.type === actions.columnDoneResizing) {
    return _extends({}, state, {
      columnResizing: _extends({}, state.columnResizing, {
        startX: null,
        isResizingColumn: null
      })
    });
  }
}

var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions(instance) {
  var flatHeaders = instance.flatHeaders,
      disableResizing = instance.disableResizing,
      getHooks = instance.getHooks,
      columnResizing = instance.state.columnResizing;
  var getInstance = useGetLatest(instance);
  flatHeaders.forEach(function (header) {
    var canResize = getFirstDefined(header.disableResizing === true ? false : undefined, disableResizing === true ? false : undefined, true);
    header.canResize = canResize;
    header.width = columnResizing.columnWidths[header.id] || header.width;
    header.isResizing = columnResizing.isResizingColumn === header.id;

    if (canResize) {
      header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
        instance: getInstance(),
        header: header
      });
    }
  });
};

function useInstance$b(_ref3) {
  var plugins = _ref3.plugins;
  ensurePluginOrder(plugins, ['useAbsoluteLayout'], 'useResizeColumns');
}

function getLeafHeaders(header) {
  var leafHeaders = [];

  var recurseHeader = function recurseHeader(header) {
    if (header.columns && header.columns.length) {
      header.columns.map(recurseHeader);
    }

    leafHeaders.push(header);
  };

  recurseHeader(header);
  return leafHeaders;
}

var cellStyles = {
  position: 'absolute',
  top: 0
};
var useAbsoluteLayout = function useAbsoluteLayout(hooks) {
  hooks.getTableBodyProps.push(getRowStyles);
  hooks.getRowProps.push(getRowStyles);
  hooks.getHeaderGroupProps.push(getRowStyles);
  hooks.getHeaderProps.push(function (props, _ref) {
    var column = _ref.column;
    return [props, {
      style: _extends({}, cellStyles, {
        left: column.totalLeft + "px",
        width: column.totalWidth + "px"
      })
    }];
  });
  hooks.getCellProps.push(function (props, _ref2) {
    var cell = _ref2.cell;
    return [props, {
      style: _extends({}, cellStyles, {
        left: cell.column.totalLeft + "px",
        width: cell.column.totalWidth + "px"
      })
    }];
  });
};
useAbsoluteLayout.pluginName = 'useAbsoluteLayout';

var getRowStyles = function getRowStyles(props, _ref3) {
  var instance = _ref3.instance;
  return [props, {
    style: {
      position: 'relative',
      width: instance.totalColumnsWidth + "px"
    }
  }];
};

var cellStyles$1 = {
  display: 'inline-block',
  boxSizing: 'border-box'
};

var getRowStyles$1 = function getRowStyles(props, _ref) {
  var instance = _ref.instance;
  return [props, {
    style: {
      display: 'flex',
      width: instance.totalColumnsWidth + "px"
    }
  }];
};

var useBlockLayout = function useBlockLayout(hooks) {
  hooks.getRowProps.push(getRowStyles$1);
  hooks.getHeaderGroupProps.push(getRowStyles$1);
  hooks.getHeaderProps.push(function (props, _ref2) {
    var column = _ref2.column;
    return [props, {
      style: _extends({}, cellStyles$1, {
        width: column.totalWidth + "px"
      })
    }];
  });
  hooks.getCellProps.push(function (props, _ref3) {
    var cell = _ref3.cell;
    return [props, {
      style: _extends({}, cellStyles$1, {
        width: cell.column.totalWidth + "px"
      })
    }];
  });
};
useBlockLayout.pluginName = 'useBlockLayout';

function useFlexLayout(hooks) {
  hooks.getTableBodyProps.push(getTableBodyProps);
  hooks.getRowProps.push(getRowStyles$2);
  hooks.getHeaderGroupProps.push(getRowStyles$2);
  hooks.getHeaderProps.push(getHeaderProps);
  hooks.getCellProps.push(getCellProps);
}
useFlexLayout.pluginName = 'useFlexLayout';

var getTableBodyProps = function getTableBodyProps(props, _ref) {
  var instance = _ref.instance;
  return [props, {
    style: {
      minWidth: instance.totalColumnsWidth + "px"
    }
  }];
};

var getRowStyles$2 = function getRowStyles(props, _ref2) {
  var instance = _ref2.instance;
  return [props, {
    style: {
      display: 'flex',
      flex: '1 0 auto',
      minWidth: instance.totalColumnsMinWidth + "px"
    }
  }];
};

var getHeaderProps = function getHeaderProps(props, _ref3) {
  var column = _ref3.column;
  return [props, {
    style: {
      boxSizing: 'border-box',
      flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
      minWidth: column.totalMinWidth + "px",
      width: column.totalWidth + "px"
    }
  }];
};

var getCellProps = function getCellProps(props, _ref4) {
  var cell = _ref4.cell;
  return [props, {
    style: {
      boxSizing: 'border-box',
      flex: cell.column.totalFlexWidth + " 0 auto",
      minWidth: cell.column.totalMinWidth + "px",
      width: cell.column.totalWidth + "px"
    }
  }];
};

export { _UNSTABLE_usePivotColumns, actions, defaultColumn, defaultGroupByFn, defaultOrderByFn, ensurePluginOrder, flexRender, functionalUpdate, loopHooks, makePropGetter, makeRenderer, reduceHooks, safeUseLayoutEffect, useAbsoluteLayout, useAsyncDebounce, useBlockLayout, useColumnOrder, useExpanded, useFilters, useFlexLayout, useGetLatest, useGlobalFilter, useGroupBy, useMountedLayoutEffect, usePagination, useResizeColumns, useRowSelect, useRowState, useSortBy, useTable };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-table/dist/index.es.js
// module id = 375
// module chunks = 0 15 16 17 18